/* THIS IS A GENERATED FILE, DO NOT EDIT */
export enum AccessGroupBulkChoices {
  IncludeAll = 'INCLUDE_ALL',
  IncludeNone = 'INCLUDE_NONE',
  NoChange = 'NO_CHANGE'
}

/** An enumeration. */
export enum AccountObjectTypeSortEnum {
  AccountTypeAsc = 'ACCOUNT_TYPE_ASC',
  AccountTypeDesc = 'ACCOUNT_TYPE_DESC',
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisregardedEntityAsc = 'DISREGARDED_ENTITY_ASC',
  DisregardedEntityDesc = 'DISREGARDED_ENTITY_DESC',
  DisregardedEntityUltimateBeneficialOwnerAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_ASC',
  DisregardedEntityUltimateBeneficialOwnerDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_DESC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_ASC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_DESC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdTypeAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_TYPE_ASC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdTypeDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_TYPE_DESC',
  EndOfExtensionPeriodsAsc = 'END_OF_EXTENSION_PERIODS_ASC',
  EndOfExtensionPeriodsDesc = 'END_OF_EXTENSION_PERIODS_DESC',
  EndOfInvestingPeriodAsc = 'END_OF_INVESTING_PERIOD_ASC',
  EndOfInvestingPeriodDesc = 'END_OF_INVESTING_PERIOD_DESC',
  EndOfInvestmentLifeAsc = 'END_OF_INVESTMENT_LIFE_ASC',
  EndOfInvestmentLifeDesc = 'END_OF_INVESTMENT_LIFE_DESC',
  GpDisplayNameAsc = 'GP_DISPLAY_NAME_ASC',
  GpDisplayNameDesc = 'GP_DISPLAY_NAME_DESC',
  InceptionDateAsc = 'INCEPTION_DATE_ASC',
  InceptionDateDesc = 'INCEPTION_DATE_DESC',
  IsInvestmentEntityAsc = 'IS_INVESTMENT_ENTITY_ASC',
  IsInvestmentEntityDesc = 'IS_INVESTMENT_ENTITY_DESC',
  LpDisplayNameAsc = 'LP_DISPLAY_NAME_ASC',
  LpDisplayNameDesc = 'LP_DISPLAY_NAME_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  OverviewAndFinancialsPublishedAsc = 'OVERVIEW_AND_FINANCIALS_PUBLISHED_ASC',
  OverviewAndFinancialsPublishedDesc = 'OVERVIEW_AND_FINANCIALS_PUBLISHED_DESC',
  PrimaryPhotoIdAsc = 'PRIMARY_PHOTO_ID_ASC',
  PrimaryPhotoIdDesc = 'PRIMARY_PHOTO_ID_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TargetStrategyAsc = 'TARGET_STRATEGY_ASC',
  TargetStrategyDesc = 'TARGET_STRATEGY_DESC',
  TaxIdAsc = 'TAX_ID_ASC',
  TaxIdDesc = 'TAX_ID_DESC',
  TransferAccountingEnabledAsc = 'TRANSFER_ACCOUNTING_ENABLED_ASC',
  TransferAccountingEnabledDesc = 'TRANSFER_ACCOUNTING_ENABLED_DESC'
}

/** An enumeration. */
export enum AchAccountOwnershipType {
  Business = 'business',
  Personal = 'personal'
}

export enum ActiveAccountsSortEnum {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** Enumeration that defines the types of addresses. */
export enum AddressType {
  Home = 'home',
  Unknown = 'unknown',
  Work = 'work'
}

/** An enumeration. */
export enum AllocationChoice {
  AccruedReturn = 'accrued_return',
  OwnershipPercentage = 'ownership_percentage'
}

/** An enumeration. */
export enum ApplicationContext {
  AdminFundAccounting = 'admin_fund_accounting'
}

/** An enumeration. */
export enum ArenaEdition {
  Full = 'full',
  GpLiteAssisted = 'gp_lite_assisted',
  GpLiteSelfServe = 'gp_lite_self_serve',
  Institutional = 'institutional',
  Professional = 'professional',
  Sponsor = 'sponsor'
}

/** An enumeration. */
export enum ArenaObjectTypeSortEnum {
  AiEnabledAsc = 'AI_ENABLED_ASC',
  AiEnabledDesc = 'AI_ENABLED_DESC',
  AllowPortalInvestorReportAsc = 'ALLOW_PORTAL_INVESTOR_REPORT_ASC',
  AllowPortalInvestorReportDesc = 'ALLOW_PORTAL_INVESTOR_REPORT_DESC',
  AssetDisclosureTextAsc = 'ASSET_DISCLOSURE_TEXT_ASC',
  AssetDisclosureTextDesc = 'ASSET_DISCLOSURE_TEXT_DESC',
  ClientPrivacyPolicyAsc = 'CLIENT_PRIVACY_POLICY_ASC',
  ClientPrivacyPolicyDesc = 'CLIENT_PRIVACY_POLICY_DESC',
  ClientTosAsc = 'CLIENT_TOS_ASC',
  ClientTosDesc = 'CLIENT_TOS_DESC',
  DocusignSoboEmailAddressAsc = 'DOCUSIGN_SOBO_EMAIL_ADDRESS_ASC',
  DocusignSoboEmailAddressDesc = 'DOCUSIGN_SOBO_EMAIL_ADDRESS_DESC',
  DocusignUserIdAsc = 'DOCUSIGN_USER_ID_ASC',
  DocusignUserIdDesc = 'DOCUSIGN_USER_ID_DESC',
  DomainAsc = 'DOMAIN_ASC',
  DomainDesc = 'DOMAIN_DESC',
  EmailDomainAsc = 'EMAIL_DOMAIN_ASC',
  EmailDomainDesc = 'EMAIL_DOMAIN_DESC',
  HasUnifiedPortalPreviewAsc = 'HAS_UNIFIED_PORTAL_PREVIEW_ASC',
  HasUnifiedPortalPreviewDesc = 'HAS_UNIFIED_PORTAL_PREVIEW_DESC',
  HideCashFlowBarChartInPortalAsc = 'HIDE_CASH_FLOW_BAR_CHART_IN_PORTAL_ASC',
  HideCashFlowBarChartInPortalDesc = 'HIDE_CASH_FLOW_BAR_CHART_IN_PORTAL_DESC',
  IdsTermsOfServiceSignedDateAsc = 'IDS_TERMS_OF_SERVICE_SIGNED_DATE_ASC',
  IdsTermsOfServiceSignedDateDesc = 'IDS_TERMS_OF_SERVICE_SIGNED_DATE_DESC',
  IsActivatedAsc = 'IS_ACTIVATED_ASC',
  IsActivatedDesc = 'IS_ACTIVATED_DESC',
  IsPartialAsc = 'IS_PARTIAL_ASC',
  IsPartialDesc = 'IS_PARTIAL_DESC',
  LoginMessageAsc = 'LOGIN_MESSAGE_ASC',
  LoginMessageDesc = 'LOGIN_MESSAGE_DESC',
  LookerInstanceIdAsc = 'LOOKER_INSTANCE_ID_ASC',
  LookerInstanceIdDesc = 'LOOKER_INSTANCE_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnershipDisplayPrecisionAsc = 'OWNERSHIP_DISPLAY_PRECISION_ASC',
  OwnershipDisplayPrecisionDesc = 'OWNERSHIP_DISPLAY_PRECISION_DESC',
  PackagingEditionIdAsc = 'PACKAGING_EDITION_ID_ASC',
  PackagingEditionIdDesc = 'PACKAGING_EDITION_ID_DESC',
  PerfMetricsAsOfDateAsc = 'PERF_METRICS_AS_OF_DATE_ASC',
  PerfMetricsAsOfDateDesc = 'PERF_METRICS_AS_OF_DATE_DESC',
  ShowDisregardedEntityQuestionnaireAsc = 'SHOW_DISREGARDED_ENTITY_QUESTIONNAIRE_ASC',
  ShowDisregardedEntityQuestionnaireDesc = 'SHOW_DISREGARDED_ENTITY_QUESTIONNAIRE_DESC',
  SmtpHostAsc = 'SMTP_HOST_ASC',
  SmtpHostDesc = 'SMTP_HOST_DESC',
  TimezoneAsc = 'TIMEZONE_ASC',
  TimezoneDesc = 'TIMEZONE_DESC',
  WelcomeMessageAsc = 'WELCOME_MESSAGE_ASC',
  WelcomeMessageDesc = 'WELCOME_MESSAGE_DESC'
}

/** An enumeration. */
export enum AssetClass {
  AMinus = 'a_minus',
  ANeutral = 'a_neutral',
  APlus = 'a_plus',
  BMinus = 'b_minus',
  BNeutral = 'b_neutral',
  BPlus = 'b_plus',
  CMinus = 'c_minus',
  CNeutral = 'c_neutral',
  CPlus = 'c_plus',
  DNeutral = 'd_neutral'
}

/** An enumeration. */
export enum AssetObjectTypeSortEnum {
  AgeRestrictedAsc = 'AGE_RESTRICTED_ASC',
  AgeRestrictedDesc = 'AGE_RESTRICTED_DESC',
  BusinessStrategyAsc = 'BUSINESS_STRATEGY_ASC',
  BusinessStrategyDesc = 'BUSINESS_STRATEGY_DESC',
  CertificateOfOccupancyDateAsc = 'CERTIFICATE_OF_OCCUPANCY_DATE_ASC',
  CertificateOfOccupancyDateDesc = 'CERTIFICATE_OF_OCCUPANCY_DATE_DESC',
  ClassUponEntryAsc = 'CLASS_UPON_ENTRY_ASC',
  ClassUponEntryDesc = 'CLASS_UPON_ENTRY_DESC',
  ClassUponStabilizationAsc = 'CLASS_UPON_STABILIZATION_ASC',
  ClassUponStabilizationDesc = 'CLASS_UPON_STABILIZATION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAcquiredAsc = 'DATE_ACQUIRED_ASC',
  DateAcquiredDesc = 'DATE_ACQUIRED_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DeveloperAsc = 'DEVELOPER_ASC',
  DeveloperDesc = 'DEVELOPER_DESC',
  EntityIdAsc = 'ENTITY_ID_ASC',
  EntityIdDesc = 'ENTITY_ID_DESC',
  ExpectedHoldMonthsAsc = 'EXPECTED_HOLD_MONTHS_ASC',
  ExpectedHoldMonthsDesc = 'EXPECTED_HOLD_MONTHS_DESC',
  ExpectedHoldYearsAsc = 'EXPECTED_HOLD_YEARS_ASC',
  ExpectedHoldYearsDesc = 'EXPECTED_HOLD_YEARS_DESC',
  FirstOccupancyDateAsc = 'FIRST_OCCUPANCY_DATE_ASC',
  FirstOccupancyDateDesc = 'FIRST_OCCUPANCY_DATE_DESC',
  GeneralContractorAsc = 'GENERAL_CONTRACTOR_ASC',
  GeneralContractorDesc = 'GENERAL_CONTRACTOR_DESC',
  GrandOpeningDateAsc = 'GRAND_OPENING_DATE_ASC',
  GrandOpeningDateDesc = 'GRAND_OPENING_DATE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ParkingSpacesAsc = 'PARKING_SPACES_ASC',
  ParkingSpacesDesc = 'PARKING_SPACES_DESC',
  PrimaryPhotoIdAsc = 'PRIMARY_PHOTO_ID_ASC',
  PrimaryPhotoIdDesc = 'PRIMARY_PHOTO_ID_DESC',
  PropertyManagerAsc = 'PROPERTY_MANAGER_ASC',
  PropertyManagerDesc = 'PROPERTY_MANAGER_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC',
  SiteWorkEndDateAsc = 'SITE_WORK_END_DATE_ASC',
  SiteWorkEndDateDesc = 'SITE_WORK_END_DATE_DESC',
  SiteWorkStartDateAsc = 'SITE_WORK_START_DATE_ASC',
  SiteWorkStartDateDesc = 'SITE_WORK_START_DATE_DESC',
  StabilizationDateAsc = 'STABILIZATION_DATE_ASC',
  StabilizationDateDesc = 'STABILIZATION_DATE_DESC',
  VerticalConstructionEndDateAsc = 'VERTICAL_CONSTRUCTION_END_DATE_ASC',
  VerticalConstructionEndDateDesc = 'VERTICAL_CONSTRUCTION_END_DATE_DESC',
  VerticalConstructionStartDateAsc = 'VERTICAL_CONSTRUCTION_START_DATE_ASC',
  VerticalConstructionStartDateDesc = 'VERTICAL_CONSTRUCTION_START_DATE_DESC',
  WebsiteUrlAsc = 'WEBSITE_URL_ASC',
  WebsiteUrlDesc = 'WEBSITE_URL_DESC',
  YearBuiltAsc = 'YEAR_BUILT_ASC',
  YearBuiltDesc = 'YEAR_BUILT_DESC',
  YearBuiltOrRenovatedAsc = 'YEAR_BUILT_OR_RENOVATED_ASC',
  YearBuiltOrRenovatedDesc = 'YEAR_BUILT_OR_RENOVATED_DESC',
  YearRenovatedAsc = 'YEAR_RENOVATED_ASC',
  YearRenovatedDesc = 'YEAR_RENOVATED_DESC',
  ZoningAsc = 'ZONING_ASC',
  ZoningDesc = 'ZONING_DESC'
}

/** An enumeration. */
export enum AssetOrEntity {
  Asset = 'asset',
  Entity = 'entity'
}

/** An enumeration. */
export enum AssetReportFieldName {
  AcquisitionDate = 'AcquisitionDate',
  AssetCurrency = 'AssetCurrency',
  AssetExtensionField = 'AssetExtensionField',
  AssetName = 'AssetName',
  AssetUpdate = 'AssetUpdate',
  AverageDailyRate = 'AverageDailyRate',
  AvgAnnualMarketRentPerSqft = 'AvgAnnualMarketRentPerSqft',
  AvgAnnualOccupiedRentPerSqft = 'AvgAnnualOccupiedRentPerSqft',
  AvgMonthlyMarketRentPerUnit = 'AvgMonthlyMarketRentPerUnit',
  AvgMonthlyOccupiedRentPerUnit = 'AvgMonthlyOccupiedRentPerUnit',
  Beds = 'Beds',
  Buildings = 'Buildings',
  BusinessStrategy = 'BusinessStrategy',
  CapRate = 'CapRate',
  CapitalExpenditures = 'CapitalExpenditures',
  City = 'City',
  ClassExpectedUponStabilization = 'ClassExpectedUponStabilization',
  ClassUponEntry = 'ClassUponEntry',
  Country = 'Country',
  CurrentEquityBalance = 'CurrentEquityBalance',
  DebtBalance = 'DebtBalance',
  DebtService = 'DebtService',
  DebtServiceCoverageRatio = 'DebtServiceCoverageRatio',
  DebtValue = 'DebtValue',
  DevelopmentSpread = 'DevelopmentSpread',
  DevelopmentStatus = 'DevelopmentStatus',
  DevelopmentYield = 'DevelopmentYield',
  DispositionDate = 'DispositionDate',
  DispositionNetSalePrice = 'DispositionNetSalePrice',
  EconomicOccupancy = 'EconomicOccupancy',
  EntityCollection = 'EntityCollection',
  EntityCurrency = 'EntityCurrency',
  ExpectedHoldMonths = 'ExpectedHoldMonths',
  ExpectedHoldYears = 'ExpectedHoldYears',
  Floors = 'Floors',
  GrossAssetValue = 'GrossAssetValue',
  GrossAssetValueEntity = 'GrossAssetValueEntity',
  GrossLeveragedEquityMultiple = 'GrossLeveragedEquityMultiple',
  GrossLeveragedIrr = 'GrossLeveragedIrr',
  GrossLeveragedResidualMultiple = 'GrossLeveragedResidualMultiple',
  GrossLeveragedYield = 'GrossLeveragedYield',
  GrossPurchaseCost = 'GrossPurchaseCost',
  GrossRealEstateValue = 'GrossRealEstateValue',
  GrossSizesMeters = 'GrossSizesMeters',
  GrossSizesSqft = 'GrossSizesSqft',
  GrossUnleveragedEquityMultiple = 'GrossUnleveragedEquityMultiple',
  GrossUnleveragedIrr = 'GrossUnleveragedIrr',
  GrossUnleveragedResidualMultiple = 'GrossUnleveragedResidualMultiple',
  GrossUnleveragedYield = 'GrossUnleveragedYield',
  InitialEquityBalance = 'InitialEquityBalance',
  Keys = 'Keys',
  LeasingStatus = 'LeasingStatus',
  LoanFirstPrincipalPaymentDates = 'LoanFirstPrincipalPaymentDates',
  LoanFloatingRateFloors = 'LoanFloatingRateFloors',
  LoanIndices = 'LoanIndices',
  LoanInitialDebtBalances = 'LoanInitialDebtBalances',
  LoanInterestRateDescriptions = 'LoanInterestRateDescriptions',
  LoanLenderNames = 'LoanLenderNames',
  LoanLenderTypes = 'LoanLenderTypes',
  LoanMaturityDates = 'LoanMaturityDates',
  LoanName = 'LoanName',
  LoanNextPaymentDueDates = 'LoanNextPaymentDueDates',
  LoanOriginationDates = 'LoanOriginationDates',
  LoanToCostRatio = 'LoanToCostRatio',
  LoanToValueRatio = 'LoanToValueRatio',
  LoanTotalAmounts = 'LoanTotalAmounts',
  LoanType = 'LoanType',
  Lots = 'Lots',
  MarketName = 'MarketName',
  MarketTier = 'MarketTier',
  NetAssetValue = 'NetAssetValue',
  NetAssetValueEntity = 'NetAssetValueEntity',
  NetCashFlowAfterDebtService = 'NetCashFlowAfterDebtService',
  NetLeveragedEquityMultiple = 'NetLeveragedEquityMultiple',
  NetLeveragedIrr = 'NetLeveragedIrr',
  NetLeveragedYield = 'NetLeveragedYield',
  NetOperatingIncome = 'NetOperatingIncome',
  NetPurchasePrice = 'NetPurchasePrice',
  NetSizesMeters = 'NetSizesMeters',
  NetSizesSqft = 'NetSizesSqft',
  NetUnleveragedCashFlow = 'NetUnleveragedCashFlow',
  OperatingExpenses = 'OperatingExpenses',
  PercentAcquired = 'PercentAcquired',
  PercentConstructionCompleted = 'PercentConstructionCompleted',
  PercentLeased = 'PercentLeased',
  Period = 'Period',
  PhysicalOccupancy = 'PhysicalOccupancy',
  ProductSubtypes = 'ProductSubtypes',
  ProductTypes = 'ProductTypes',
  ProjectedDevelopmentSpread = 'ProjectedDevelopmentSpread',
  ProjectedDevelopmentYield = 'ProjectedDevelopmentYield',
  ProjectedGrossLeveragedEquityMultiple = 'ProjectedGrossLeveragedEquityMultiple',
  ProjectedGrossLeveragedIrr = 'ProjectedGrossLeveragedIrr',
  ProjectedNetLeveragedEquityMultiple = 'ProjectedNetLeveragedEquityMultiple',
  ProjectedNetLeveragedIrr = 'ProjectedNetLeveragedIrr',
  Revenue = 'Revenue',
  RiskProfile = 'RiskProfile',
  State = 'State',
  StreetAddress = 'StreetAddress',
  SubmarketName = 'SubmarketName',
  TotalInterestRate = 'TotalInterestRate',
  Units = 'Units',
  YearBuilt = 'YearBuilt',
  YearLastRenovated = 'YearLastRenovated',
  Zip = 'Zip'
}

/** An enumeration. */
export enum AssetReportSelectableRelativePeriodDeltaFields {
  AverageDailyRate = 'AverageDailyRate',
  AvgAnnualMarketRentPerSqft = 'AvgAnnualMarketRentPerSqft',
  AvgMonthlyMarketRentPerUnit = 'AvgMonthlyMarketRentPerUnit',
  AvgMonthlyOccupiedRentPerUnit = 'AvgMonthlyOccupiedRentPerUnit',
  CapitalExpenditures = 'CapitalExpenditures',
  DebtService = 'DebtService',
  DevelopmentSpread = 'DevelopmentSpread',
  DevelopmentYield = 'DevelopmentYield',
  EconomicOccupancy = 'EconomicOccupancy',
  GrossLeveragedEquityMultiple = 'GrossLeveragedEquityMultiple',
  GrossLeveragedIrr = 'GrossLeveragedIrr',
  GrossLeveragedResidualMultiple = 'GrossLeveragedResidualMultiple',
  GrossLeveragedYield = 'GrossLeveragedYield',
  GrossUnleveragedEquityMultiple = 'GrossUnleveragedEquityMultiple',
  GrossUnleveragedIrr = 'GrossUnleveragedIrr',
  GrossUnleveragedResidualMultiple = 'GrossUnleveragedResidualMultiple',
  GrossUnleveragedYield = 'GrossUnleveragedYield',
  NetCashFlowAfterDebtService = 'NetCashFlowAfterDebtService',
  NetLeveragedEquityMultiple = 'NetLeveragedEquityMultiple',
  NetLeveragedIrr = 'NetLeveragedIrr',
  NetLeveragedYield = 'NetLeveragedYield',
  NetOperatingIncome = 'NetOperatingIncome',
  NetUnleveragedCashFlow = 'NetUnleveragedCashFlow',
  OperatingExpenses = 'OperatingExpenses',
  PercentConstructionCompleted = 'PercentConstructionCompleted',
  PercentLeased = 'PercentLeased',
  PhysicalOccupancy = 'PhysicalOccupancy',
  Revenue = 'Revenue'
}

/** An enumeration. */
export enum AssetReportTemplateLayout {
  Default = 'default'
}

/** An enumeration. */
export enum AssetReportTemplateModuleFieldObjectTypeSortEnum {
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

/** An enumeration. */
export enum AssetReportTemplateModuleObjectTypeSortEnum {
  AssetReportTemplateModuleTypeAsc = 'ASSET_REPORT_TEMPLATE_MODULE_TYPE_ASC',
  AssetReportTemplateModuleTypeDesc = 'ASSET_REPORT_TEMPLATE_MODULE_TYPE_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TitleEnabledAsc = 'TITLE_ENABLED_ASC',
  TitleEnabledDesc = 'TITLE_ENABLED_DESC'
}

/** An enumeration. */
export enum AssetReportTemplateModuleType {
  AssetDescription = 'asset_description',
  AssetUpdate = 'asset_update',
  DataList = 'data_list',
  Subtitle = 'subtitle'
}

/** An enumeration. */
export enum AssetReportTemplateObjectTypeSortEnum {
  LayoutAsc = 'LAYOUT_ASC',
  LayoutDesc = 'LAYOUT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** An enumeration. */
export enum AssetsClass {
  Other = 'other',
  PrivateDebt = 'private_debt',
  PrivateEquity = 'private_equity',
  RealEstate = 'real_estate',
  VentureCapital = 'venture_capital'
}

/** An enumeration. */
export enum AsyncJobObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  JobTypeAsc = 'JOB_TYPE_ASC',
  JobTypeDesc = 'JOB_TYPE_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** An enumeration. */
export enum AuthorizedClass {
  Account = 'account',
  Contact = 'contact',
  CustomDataFields = 'custom_data_fields',
  DocumentCategory = 'document_category',
  Entity = 'entity',
  Offering = 'offering',
  Ticket = 'ticket'
}

/** An enumeration. */
export enum BankAccountType {
  Checking = 'checking',
  Savings = 'savings'
}

/** An enumeration. */
export enum BusinessStrategy {
  BuyAndHold = 'buy_and_hold',
  DevelopAndHold = 'develop_and_hold',
  DevelopAndSell = 'develop_and_sell',
  ImmediateSale = 'immediate_sale',
  RepositionAndHold = 'reposition_and_hold',
  RepositionAndSell = 'reposition_and_sell'
}

/** An enumeration. */
export enum CapitalCallObjectTypeSortEnum {
  HasDefaultedAsc = 'HAS_DEFAULTED_ASC',
  HasDefaultedDesc = 'HAS_DEFAULTED_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** GraphQL enum for chart widget types. */
export enum ChartWidgetTypeEnum {
  Column = 'column',
  Combo = 'combo',
  Donut = 'donut',
  HorizontalBar = 'horizontal_bar',
  Line = 'line'
}

/** Enum for S3 client methods that can be used with presigned URLs */
export enum ClientMethodEnum {
  GetObject = 'GET_OBJECT',
  PutObject = 'PUT_OBJECT'
}

/**
 * Delivery precedence for a communication pref.
 *
 *     Matches the jsq-email-svc ``DeliveryPref`` enum (values 1–4).
 *
 */
export enum CommPrefDeliveryType {
  Bcc = 'bcc',
  Cc = 'cc',
  PortalOnly = 'portal_only',
  To = 'to'
}

/** An enumeration. */
export enum ConsolidationStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  EmailSent = 'email_sent',
  Started = 'started'
}

/** An enumeration. */
export enum ContactObjectTypeSortEnum {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  JobTitleAsc = 'JOB_TITLE_ASC',
  JobTitleDesc = 'JOB_TITLE_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LinkedinUrlAsc = 'LINKEDIN_URL_ASC',
  LinkedinUrlDesc = 'LINKEDIN_URL_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  PreqinIdAsc = 'PREQIN_ID_ASC',
  PreqinIdDesc = 'PREQIN_ID_DESC',
  ReferrerNameAsc = 'REFERRER_NAME_ASC',
  ReferrerNameDesc = 'REFERRER_NAME_DESC',
  SalutationNameAsc = 'SALUTATION_NAME_ASC',
  SalutationNameDesc = 'SALUTATION_NAME_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  WebsiteUrlAsc = 'WEBSITE_URL_ASC',
  WebsiteUrlDesc = 'WEBSITE_URL_DESC'
}

/** Enumeration that defines the types of contacts.  Used in ContactModel. */
export enum ContactType {
  Organization = 'organization',
  Person = 'person'
}

/** Used exclusively for inputs. This is due to federation requiring input enums to be updated across all subgraphs if changes are needed. */
export enum ContactTypeFilterEnum {
  Organization = 'organization',
  Person = 'person'
}

/** An enumeration. */
export enum ContentType {
  TextHtml = 'text_html',
  TextPlain = 'text_plain'
}

export enum CoordinatesRadiusType {
  Kilometers = 'kilometers',
  Miles = 'miles'
}

/** An enumeration. */
export enum CountryObjectTypeSortEnum {
  Alpha2CodeAsc = 'ALPHA2CODE_ASC',
  Alpha2CodeDesc = 'ALPHA2CODE_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PopulationAsc = 'POPULATION_ASC',
  PopulationDesc = 'POPULATION_DESC'
}

/** An enumeration. */
export enum CropType {
  Almonds = 'almonds',
  Apples = 'apples',
  Corn = 'corn',
  Cotton = 'cotton',
  FreshVegetables = 'fresh_vegetables',
  Oranges = 'oranges',
  OtherAnnual = 'other_annual',
  OtherCitrus = 'other_citrus',
  OtherPermanent = 'other_permanent',
  Pistachios = 'pistachios',
  Rice = 'rice',
  Soybeans = 'soybeans',
  Wheat = 'wheat',
  WineGrapes = 'wine_grapes'
}

/** An enumeration. */
export enum CurrencyCode {
  Aed = 'AED',
  Ars = 'ARS',
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Pen = 'PEN',
  Pln = 'PLN',
  Ron = 'RON',
  Rub = 'RUB',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Twd = 'TWD',
  Uah = 'UAH',
  Usd = 'USD',
  Uyu = 'UYU',
  Vnd = 'VND',
  Zar = 'ZAR'
}

/** Supported recipient object types for template-driven preview PDF generation. */
export enum CustomReportRecipientObjectType {
  Account = 'account',
  Contact = 'contact',
  Position = 'position'
}

export enum DateFilterType {
  Blank = 'blank',
  Equals = 'equals',
  GreaterThan = 'greater_than',
  InRange = 'in_range',
  LessThan = 'less_than',
  NotBlank = 'not_blank',
  NotEquals = 'not_equals'
}

/** Default sender address for emails. */
export enum DefaultEmailSender {
  SharedAddress = 'SHARED_ADDRESS',
  UserPersonal = 'USER_PERSONAL'
}

/** An enumeration. */
export enum DeltaDirection {
  From = 'from_',
  To = 'to_'
}

/** An enumeration. */
export enum DeveloperFeatureFlags {
  AccessProspectSubscriptionPermission = 'access_prospect_subscription_permission',
  AutomatedPaymentBatchesSummaryDownload = 'automated_payment_batches_summary_download',
  AutomatedPaymentsAchDebit = 'automated_payments_ach_debit',
  AutomatedPaymentsDistributionsUi = 'automated_payments_distributions_ui',
  AutomatedPaymentsEmailNotifications = 'automated_payments_email_notifications',
  BankAccountSwiftUi = 'bank_account_swift_ui',
  BroadstreetPerformanceOptimization = 'broadstreet_performance_optimization',
  BulkAddOrgProspects = 'bulk_add_org_prospects',
  BulkUpdatingCommitmentAmounts = 'bulk_updating_commitment_amounts',
  CanopyDistributionPayments = 'canopy_distribution_payments',
  CapabilityLayerForAutomatedPayments = 'capability_layer_for_automated_payments',
  CcTransactionBatchSingleTransactionEnforcement = 'cc_transaction_batch_single_transaction_enforcement',
  CommSettingsModal = 'comm_settings_modal',
  ComplianceSettingsPanelUpdate = 'compliance_settings_panel_update',
  ContactsPortalInvite = 'contacts_portal_invite',
  ContributionEffectiveDate = 'contribution_effective_date',
  DataRoomRestrictDownloads = 'data_room_restrict_downloads',
  DeduplicateAccount = 'deduplicate_account',
  DeprecateLegacyCustomSections = 'deprecate_legacy_custom_sections',
  DisregardedEntityQuestionnaire = 'disregarded_entity_questionnaire',
  DocumentCategoryAdvancedPermissions = 'document_category_advanced_permissions',
  DocumentFlowOptimization = 'document_flow_optimization',
  DocumentFolderSorting = 'document_folder_sorting',
  DocumentMatchAlgorithmV1 = 'document_match_algorithm_v1',
  DocumentMatchAndShareAlgorithmImprovements = 'document_match_and_share_algorithm_improvements',
  DocumentMatchAndSharePerformanceImprovements = 'document_match_and_share_performance_improvements',
  DocumentMatchAndShareScoreImprovements = 'document_match_and_share_score_improvements',
  DocumentMatchAndShareUiFeedback = 'document_match_and_share_ui_feedback',
  DocusignWebhookSafeMode = 'docusign_webhook_safe_mode',
  EnableCoBrowseFeature = 'enable_co_browse_feature',
  EnableComplianceAutomatedScreening = 'enable_compliance_automated_screening',
  EnableComplianceEscalationFlow = 'enable_compliance_escalation_flow',
  EnableComplianceKyc = 'enable_compliance_kyc',
  EnableComplianceScreening = 'enable_compliance_screening',
  EnableDiagonalDocumentWatermarking = 'enable_diagonal_document_watermarking',
  EnableEnhancedEditorTemplating = 'enable_enhanced_editor_templating',
  EnableEntitySettings = 'enable_entity_settings',
  EnableLpEditPaymentPreferenceAdminSettings = 'enable_lp_edit_payment_preference_admin_settings',
  EnableLpQuestionnairePrefill = 'enable_lp_questionnaire_prefill',
  EnableLpcmCommPrefsSubscription = 'enable_lpcm_comm_prefs_subscription',
  EnableMicrosoftOauthIntegration = 'enable_microsoft_oauth_integration',
  EnableMobileContactFiltering = 'enable_mobile_contact_filtering',
  EnableOperatingCompanies = 'enable_operating_companies',
  EnableOutlookAddInAuthNaa = 'enable_outlook_add_in_auth_naa',
  EnableParallelDocumentScore = 'enable_parallel_document_score',
  EnableReactifiedEmailPreview = 'enable_reactified_email_preview',
  EnableScheduledEmails = 'enable_scheduled_emails',
  EnableYtdTtmItdForPcap = 'enable_ytd_ttm_itd_for_pcap',
  EnablementAnnouncements = 'enablement_announcements',
  EnhancedEditorM1 = 'enhanced_editor_m1',
  EquitiesPerformanceOptimization = 'equities_performance_optimization',
  ExportSubsCsv = 'export_subs_csv',
  ExternalAuthentication = 'external_authentication',
  GpxIntegrations = 'gpx_integrations',
  HasFidesIntegration = 'has_fides_integration',
  HasGpxKycPaymentsOnboarding = 'has_gpx_kyc_payments_onboarding',
  HasKycInUnifiedPortal = 'has_kyc_in_unified_portal',
  HasSkippedEmailResend = 'has_skipped_email_resend',
  HubspotIntegration = 'hubspot_integration',
  InvestorPortalUserProfile = 'investor_portal_user_profile',
  InviteManager = 'invite_manager',
  LpRequestManagementM1 = 'lp_request_management_m1',
  LpRequestManagementM2 = 'lp_request_management_m2',
  LpZendeskFeatureFlag = 'lp_zendesk_feature_flag',
  LpZendeskMessagingWidget = 'lp_zendesk_messaging_widget',
  MainGlDataExportEnabled = 'main_gl_data_export_enabled',
  ManageActivityStaffPermission = 'manage_activity_staff_permission',
  NewInvestorQuestionnairePreview = 'new_investor_questionnaire_preview',
  NewSubscriptionAccountType = 'new_subscription_account_type',
  NotifyBankAccountChangeDiligence = 'notify_bank_account_change_diligence',
  OfferingsAdvancedPermissions = 'offerings_advanced_permissions',
  OfflineGpxOnboarding = 'offline_gpx_onboarding',
  OutlookReactifyLogin = 'outlook_reactify_login',
  PaymentsLpComplianceScreening = 'payments_lp_compliance_screening',
  PoToolsLoadPaymentInstInvestorGroup = 'po_tools_load_payment_inst_investor_group',
  PoToolsLoadPaymentInstructions = 'po_tools_load_payment_instructions',
  PoToolsLoadPositionTransactions = 'po_tools_load_position_transactions',
  PoToolsLoadTransactions = 'po_tools_load_transactions',
  PoToolsLoadTransactionsJsqIdAndExternalId = 'po_tools_load_transactions_jsq_id_and_external_id',
  PortalDatetimeInternationalization = 'portal_datetime_internationalization',
  PositionHistoryFunctionOptimization = 'position_history_function_optimization',
  PreqinIntegration = 'preqin_integration',
  PrivateEdgeTemplateExport = 'private_edge_template_export',
  ProspectBaseQueryOptimization = 'prospect_base_query_optimization',
  ProspectDocumentShare = 'prospect_document_share',
  ProspectOptimizationSubscriptionFiltering = 'prospect_optimization_subscription_filtering',
  PublicationsLimitLastTwelveMonths = 'publications_limit_last_twelve_months',
  PublicationsPreviewBulkDownload = 'publications_preview_bulk_download',
  PublishToDataFabric = 'publish_to_data_fabric',
  Q2AssetDataEnhancementsV2 = 'q2_asset_data_enhancements_v2',
  QueueUploadDocuments = 'queue_upload_documents',
  ReactifyMatchAndShare = 'reactify_match_and_share',
  RecoveryCodes = 'recovery_codes',
  SftpDocumentPosting = 'sftp_document_posting',
  ShowActivityEditedTooltip = 'show_activity_edited_tooltip',
  ShowComplianceCanopyNestedOwnership = 'show_compliance_canopy_nested_ownership',
  SubscriptionAiDocumentExtraction = 'subscription_ai_document_extraction',
  SubscriptionBulkCountersign = 'subscription_bulk_countersign',
  SubscriptionFootnotes = 'subscription_footnotes',
  SubscriptionInternationalTax = 'subscription_international_tax',
  SubscriptionSubquestions = 'subscription_subquestions',
  SwiftPayments = 'swift_payments',
  TaxDocDeliveryPreferences = 'tax_doc_delivery_preferences',
  TotpAuth = 'totp_auth',
  TransferBatchDetailsRefactor = 'transfer_batch_details_refactor',
  TrxTotalsWithPmx = 'trx_totals_with_pmx',
  TurnOffEmailForAccountCommunication = 'turn_off_email_for_account_communication',
  UndeliverableSmsEmailRerouting = 'undeliverable_sms_email_rerouting',
  UnifiedPortal = 'unified_portal',
  UseInvestmentPositionId = 'use_investment_position_id',
  UseRefactoredProfileRelationships = 'use_refactored_profile_relationships',
  UseUpdatedOwnershipQueriesFf = 'use_updated_ownership_queries_ff',
  WriteSubsV3States = 'write_subs_v3_states',
  ZapierIntegration = 'zapier_integration',
  ZendeskMessagingWidget = 'zendesk_messaging_widget'
}

/** An enumeration. */
export enum DiligenceCategory {
  PaymentsOnboardingFlow = 'payments_onboarding_flow',
  SubscriptionsFlow = 'subscriptions_flow'
}

/** An enumeration. */
export enum DistributionObjectTypeSortEnum {
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum DocumentCategoryObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  EmailDistributionListIdAsc = 'EMAIL_DISTRIBUTION_LIST_ID_ASC',
  EmailDistributionListIdDesc = 'EMAIL_DISTRIBUTION_LIST_ID_DESC',
  IsTaxCategoryAsc = 'IS_TAX_CATEGORY_ASC',
  IsTaxCategoryDesc = 'IS_TAX_CATEGORY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RequiresLoginAsc = 'REQUIRES_LOGIN_ASC',
  RequiresLoginDesc = 'REQUIRES_LOGIN_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

/** Types of document enrichments. */
export enum DocumentEnrichmentType {
  HtmlWatermark = 'HTML_WATERMARK',
  PasswordProtection = 'PASSWORD_PROTECTION'
}

export enum DocumentFolderSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FolderSortRankAsc = 'FOLDER_SORT_RANK_ASC',
  FolderSortRankDesc = 'FOLDER_SORT_RANK_DESC'
}

/** An enumeration. */
export enum DocumentFolderState {
  Created = 'CREATED',
  Deleted = 'DELETED'
}

/** An enumeration. */
export enum DocumentObjectTypeSortEnum {
  IsCollectionAsc = 'IS_COLLECTION_ASC',
  IsCollectionDesc = 'IS_COLLECTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NdaIdAsc = 'NDA_ID_ASC',
  NdaIdDesc = 'NDA_ID_DESC',
  ReviewStatusAsc = 'REVIEW_STATUS_ASC',
  ReviewStatusDesc = 'REVIEW_STATUS_DESC',
  SortingDateAsc = 'SORTING_DATE_ASC',
  SortingDateDesc = 'SORTING_DATE_DESC'
}

/** The review status of a document in the approval workflow. */
export enum DocumentReviewStatus {
  Approved = 'APPROVED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  Published = 'PUBLISHED',
  ReviewInProgress = 'REVIEW_IN_PROGRESS'
}

/** An enumeration. */
export enum DocumentSignatories {
  ByAccount = 'by_account',
  ByContact = 'by_contact'
}

/** An enumeration. */
export enum DocumentSourceType {
  Account = 'account',
  Arena = 'arena',
  Contact = 'contact',
  Offering = 'offering',
  Position = 'position'
}

/** An enumeration. */
export enum DocumentWatermarkObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  HtmlAsc = 'HTML_ASC',
  HtmlDesc = 'HTML_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PlacementAsc = 'PLACEMENT_ASC',
  PlacementDesc = 'PLACEMENT_DESC'
}

/** An enumeration. */
export enum ESignatureExecutedDocumentObjectTypeSortEnum {
  ESignatureRequestIdAsc = 'E_SIGNATURE_REQUEST_ID_ASC',
  ESignatureRequestIdDesc = 'E_SIGNATURE_REQUEST_ID_DESC'
}

/** An enumeration. */
export enum ESignatureGpSignerObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  ESignatureRequestIdAsc = 'E_SIGNATURE_REQUEST_ID_ASC',
  ESignatureRequestIdDesc = 'E_SIGNATURE_REQUEST_ID_DESC',
  IsEmbeddedAsc = 'IS_EMBEDDED_ASC',
  IsEmbeddedDesc = 'IS_EMBEDDED_DESC',
  NotificationPreferenceAsc = 'NOTIFICATION_PREFERENCE_ASC',
  NotificationPreferenceDesc = 'NOTIFICATION_PREFERENCE_DESC',
  SignedDateAsc = 'SIGNED_DATE_ASC',
  SignedDateDesc = 'SIGNED_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum ESignatureLpSignerObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  ChainOfSigningAuthorityAsc = 'CHAIN_OF_SIGNING_AUTHORITY_ASC',
  ChainOfSigningAuthorityDesc = 'CHAIN_OF_SIGNING_AUTHORITY_DESC',
  EmailAddressAsc = 'EMAIL_ADDRESS_ASC',
  EmailAddressDesc = 'EMAIL_ADDRESS_DESC',
  EntityNameAsc = 'ENTITY_NAME_ASC',
  EntityNameDesc = 'ENTITY_NAME_DESC',
  EntityTitleAsc = 'ENTITY_TITLE_ASC',
  EntityTitleDesc = 'ENTITY_TITLE_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IsDesignatedFormFillerAsc = 'IS_DESIGNATED_FORM_FILLER_ASC',
  IsDesignatedFormFillerDesc = 'IS_DESIGNATED_FORM_FILLER_DESC',
  IsLegalEntityAsc = 'IS_LEGAL_ENTITY_ASC',
  IsLegalEntityDesc = 'IS_LEGAL_ENTITY_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum ESignatureRequestBatchObjectTypeSortEnum {
  SentDateAsc = 'SENT_DATE_ASC',
  SentDateDesc = 'SENT_DATE_DESC'
}

/** An enumeration. */
export enum ESignatureRequestObjectTypeSortEnum {
  LpSignersSentDateAsc = 'LP_SIGNERS_SENT_DATE_ASC',
  LpSignersSentDateDesc = 'LP_SIGNERS_SENT_DATE_DESC',
  ReminderLastSentDateAsc = 'REMINDER_LAST_SENT_DATE_ASC',
  ReminderLastSentDateDesc = 'REMINDER_LAST_SENT_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** An enumeration. */
export enum ESignatureRequestRecipientObjectTypeSortEnum {
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC'
}

/** An enumeration. */
export enum ESignatureRequestStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Declined = 'declined',
  Downloading = 'downloading',
  Draft = 'draft',
  Failed = 'failed',
  SentForConfiguration = 'sent_for_configuration',
  SentForSignature = 'sent_for_signature',
  Voided = 'voided'
}

/** An enumeration. */
export enum ESignatureRequestTemplateGpSignerObjectTypeSortEnum {
  ESignatureRequestTemplateIdAsc = 'E_SIGNATURE_REQUEST_TEMPLATE_ID_ASC',
  ESignatureRequestTemplateIdDesc = 'E_SIGNATURE_REQUEST_TEMPLATE_ID_DESC',
  IsEmbeddedAsc = 'IS_EMBEDDED_ASC',
  IsEmbeddedDesc = 'IS_EMBEDDED_DESC',
  NotificationPreferenceAsc = 'NOTIFICATION_PREFERENCE_ASC',
  NotificationPreferenceDesc = 'NOTIFICATION_PREFERENCE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum ESignatureRequestTemplateStatus {
  Completed = 'completed',
  Draft = 'draft'
}

/**
 *
 *     This should actually be interpreted as the current step for the flow
 *     instead of the last validated step.
 *
 */
export enum ESignatureRequestTemplateStep {
  DraftEmail = 'draft_email',
  Finalized = 'finalized',
  InitialSetup = 'initial_setup',
  Recipients = 'recipients',
  ReviewAndSend = 'review_and_send',
  SignatureSettings = 'signature_settings'
}

/**
 * Status used to map from DocuSign envelope recipient status to our own enum. This applies to LP and GP signers
 *     tables: e_signature_lp_signer and e_signature_gp_signer, respectively.
 *
 *     For more information on these statuses,
 *     see https://developers.docusign.com/docs/esign-rest-api/esign101/concepts/recipients/.
 *
 */
export enum ESignatureSignerStatus {
  Autoresponded = 'autoresponded',
  Completed = 'completed',
  CompletedOutOfSync = 'completed_out_of_sync',
  Created = 'created',
  Declined = 'declined',
  Delivered = 'delivered',
  Faxpending = 'faxpending',
  Sent = 'sent',
  Signed = 'signed'
}

/** An enumeration. */
export enum EditorTemplateObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  HtmlBodyAsc = 'HTML_BODY_ASC',
  HtmlBodyDesc = 'HTML_BODY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC',
  SavedToAllObjectsAsc = 'SAVED_TO_ALL_OBJECTS_ASC',
  SavedToAllObjectsDesc = 'SAVED_TO_ALL_OBJECTS_DESC',
  TemplateMetadataAsc = 'TEMPLATE_METADATA_ASC',
  TemplateMetadataDesc = 'TEMPLATE_METADATA_DESC',
  TemplateTypeAsc = 'TEMPLATE_TYPE_ASC',
  TemplateTypeDesc = 'TEMPLATE_TYPE_DESC'
}

/** An enumeration. */
export enum EditorTemplateType {
  CapitalCallReminder = 'CAPITAL_CALL_REMINDER',
  DataRoomInvitation = 'DATA_ROOM_INVITATION',
  ElectronicDeliveryConsent = 'ELECTRONIC_DELIVERY_CONSENT',
  EmailAccount = 'EMAIL_ACCOUNT',
  EmailAccountStatement = 'EMAIL_ACCOUNT_STATEMENT',
  EmailCapitalActivityNotice = 'EMAIL_CAPITAL_ACTIVITY_NOTICE',
  EmailCapitalCallNotice = 'EMAIL_CAPITAL_CALL_NOTICE',
  EmailContact = 'EMAIL_CONTACT',
  EmailDistributionNotice = 'EMAIL_DISTRIBUTION_NOTICE',
  EmailEntity = 'EMAIL_ENTITY',
  EmailInvestorReport = 'EMAIL_INVESTOR_REPORT',
  EmailManagementFeeNotice = 'EMAIL_MANAGEMENT_FEE_NOTICE',
  EmailNetAssetValueStatement = 'EMAIL_NET_ASSET_VALUE_STATEMENT',
  EmailNetIncomeNotice = 'EMAIL_NET_INCOME_NOTICE',
  EmailNetNotice = 'EMAIL_NET_NOTICE',
  EmailOffering = 'EMAIL_OFFERING',
  KycRequestBatch = 'KYC_REQUEST_BATCH',
  KycRequestVerification = 'KYC_REQUEST_VERIFICATION',
  PortalInvitation = 'PORTAL_INVITATION',
  PortalUpgrade = 'PORTAL_UPGRADE',
  ProvideDisregardedEntityInfo = 'PROVIDE_DISREGARDED_ENTITY_INFO',
  PublicationAccountStatement = 'PUBLICATION_ACCOUNT_STATEMENT',
  PublicationCapitalActivityNotice = 'PUBLICATION_CAPITAL_ACTIVITY_NOTICE',
  PublicationCapitalCallNotice = 'PUBLICATION_CAPITAL_CALL_NOTICE',
  PublicationDistributionNotice = 'PUBLICATION_DISTRIBUTION_NOTICE',
  PublicationDistributionNoticeSummary = 'PUBLICATION_DISTRIBUTION_NOTICE_SUMMARY',
  PublicationInvestorReport = 'PUBLICATION_INVESTOR_REPORT',
  PublicationManagementFeeNotice = 'PUBLICATION_MANAGEMENT_FEE_NOTICE',
  PublicationNetAssetValueStatement = 'PUBLICATION_NET_ASSET_VALUE_STATEMENT',
  PublicationNetIncomeNotice = 'PUBLICATION_NET_INCOME_NOTICE',
  PublicationNetNoticeCapitalCall = 'PUBLICATION_NET_NOTICE_CAPITAL_CALL',
  PublicationNetNoticeDistribution = 'PUBLICATION_NET_NOTICE_DISTRIBUTION',
  PublicationNetNoticeNetCapitalCall = 'PUBLICATION_NET_NOTICE_NET_CAPITAL_CALL',
  PublicationNetNoticeNetDistribution = 'PUBLICATION_NET_NOTICE_NET_DISTRIBUTION',
  PurchaseKyc = 'PURCHASE_KYC',
  SubscriptionConfirmation = 'SUBSCRIPTION_CONFIRMATION',
  SubscriptionInvitation = 'SUBSCRIPTION_INVITATION',
  UpdatePaymentPrefs = 'UPDATE_PAYMENT_PREFS'
}

/** An enumeration. */
export enum EmailDistributionListObjectTypeSortEnum {
  CanInvestorsManageAsc = 'CAN_INVESTORS_MANAGE_ASC',
  CanInvestorsManageDesc = 'CAN_INVESTORS_MANAGE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NewContactDefaultAsc = 'NEW_CONTACT_DEFAULT_ASC',
  NewContactDefaultDesc = 'NEW_CONTACT_DEFAULT_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

export enum EmailErrorEnum {
  ContactDeleted = 'CONTACT_DELETED',
  InvalidEmail = 'INVALID_EMAIL',
  NoEmailAddress = 'NO_EMAIL_ADDRESS',
  NoRecipients = 'NO_RECIPIENTS'
}

/** An enumeration. */
export enum EmailRecipientType {
  Bcc = 'BCC',
  Cc = 'CC',
  To = 'TO'
}

export enum EmailSettingsVerificationStates {
  NotSet = 'NotSet',
  NotVerified = 'NotVerified',
  PartiallyVerified = 'PartiallyVerified',
  Verified = 'Verified'
}

/** Enumeration that defines the types of email addresses.  Used in ContactEmailModel. */
export enum EmailType {
  Personal = 'personal',
  Unknown = 'unknown',
  Work = 'work'
}

/** An enumeration. */
export enum EntityCollectionObjectTypeSortEnum {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** An enumeration. */
export enum EntityStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
}

/**
 *
 *     This represents the available options for filtering the investment entities in the LP Portal.
 *     This enables the user to filter the investment entities based on their status for Investment Entities in both the
 *     investments tab and the Dashboard.
 *
 */
export enum EntityStatusOptionsEnum {
  Active = 'active',
  All = 'all',
  Completed = 'completed'
}

/** An enumeration. */
export enum EntitySubTypeObjectTypeSortEnum {
  HiddenAsc = 'HIDDEN_ASC',
  HiddenDesc = 'HIDDEN_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum EntityTotalsPeriodOptions {
  CurrentPeriod = 'current_period',
  PreviousPeriod = 'previous_period'
}

/** Enumerates the set of event types that can be triggered by a user. */
export enum EventType {
  Accept = 'accept',
  AcceptMobileTos = 'accept_mobile_tos',
  AcceptTos = 'accept_tos',
  AccessESignatureCcLog = 'access_e_signature_cc_log',
  AccessInsightsDashboard = 'access_insights_dashboard',
  AccessInvestorDiligenceCcLog = 'access_investor_diligence_cc_log',
  AccessSubscriptionCcLog = 'access_subscription_cc_log',
  Activate = 'activate',
  ActivateUser = 'activate_user',
  AddTo = 'add_to',
  BulkCountersignGpSigned = 'bulk_countersign_gp_signed',
  BulkImportAccounts = 'bulk_import_accounts',
  BulkImportContact = 'bulk_import_contact',
  BulkImportOwnership = 'bulk_import_ownership',
  BulkImportPositions = 'bulk_import_positions',
  Create = 'create',
  DataRoomInvitationSent = 'data_room_invitation_sent',
  DeclineTos = 'decline_tos',
  DecryptAccount = 'decrypt_account',
  Delete = 'delete',
  Download = 'download',
  Download_2faRecoveryCodes = 'download_2fa_recovery_codes',
  DownloadGpTemplate = 'download_gp_template',
  ElectronicDeliveryConsent = 'electronic_delivery_consent',
  Email_2faSend = 'email_2fa_send',
  Email_2faSendLocked = 'email_2fa_send_locked',
  ExecutedNdaUploaded = 'executed_nda_uploaded',
  Expire_2faRecoveryCodes = 'expire_2fa_recovery_codes',
  Export = 'export',
  Generate_2faRecoveryCodes = 'generate_2fa_recovery_codes',
  Impersonate = 'impersonate',
  ImportAssetData = 'import_asset_data',
  ImportContacts = 'import_contacts',
  LinkLegacyToGlobalUser = 'link_legacy_to_global_user',
  Merge = 'merge',
  MigrateOfferingToCategories = 'migrate_offering_to_categories',
  MigrateOfferingToSubfolders = 'migrate_offering_to_subfolders',
  NdaExecuted = 'nda_executed',
  PasswordReset = 'password_reset',
  PasswordUpdate = 'password_update',
  PortalPublish = 'portal_publish',
  PortalPublishFinancials = 'portal_publish_financials',
  PortalPublishMetrics = 'portal_publish_metrics',
  PortalUnpublish = 'portal_unpublish',
  PortalUnpublishFinancials = 'portal_unpublish_financials',
  PortalUnpublishMetrics = 'portal_unpublish_metrics',
  ProcessApNoc = 'process_ap_noc',
  RemoveFrom = 'remove_from',
  SessionUuidCreate = 'session_uuid_create',
  SessionUuidDelete = 'session_uuid_delete',
  SessionUuidSetSessionExchange = 'session_uuid_set_session_exchange',
  Sms_2faSend = 'sms_2fa_send',
  Sms_2faSendLocked = 'sms_2fa_send_locked',
  StaffOrHybrid_2faDowngrade = 'staff_or_hybrid_2fa_downgrade',
  SubscriptionLpSigned = 'subscription_lp_signed',
  Undelete = 'undelete',
  UnlinkArenaBoundUser = 'unlink_arena_bound_user',
  Update = 'update',
  Update_2faPolicy = 'update_2fa_policy',
  UpdateESignatureSettings = 'update_e_signature_settings',
  Used_2faRecoveryCode = 'used_2fa_recovery_code',
  User_2faPhoneUpdated = 'user_2fa_phone_updated',
  User_2faUpdated = 'user_2fa_updated',
  UserLocked = 'user_locked'
}

/** An enumeration. */
export enum ExtensionFieldType {
  CurrencyUsd = 'currency_usd',
  CurrencyUsdRange = 'currency_usd_range',
  Date = 'date',
  DateRange = 'date_range',
  Datetime = 'datetime',
  Enumeration = 'enumeration',
  Float = 'float',
  IntRange = 'int_range',
  Integer = 'integer',
  NumericRange = 'numeric_range',
  Percentile = 'percentile',
  PercentileRange = 'percentile_range',
  Text = 'text'
}

/** An enumeration. */
export enum FeatureFlagObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DefaultValueAsc = 'DEFAULT_VALUE_ASC',
  DefaultValueDesc = 'DEFAULT_VALUE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerObjectTypeAsc = 'OWNER_OBJECT_TYPE_ASC',
  OwnerObjectTypeDesc = 'OWNER_OBJECT_TYPE_DESC'
}

export enum FeedbackDestinationTypes {
  InstitutionalPortalHomepage = 'institutional_portal_homepage',
  MultiManagerPortalHomepage = 'multi_manager_portal_homepage'
}

/** An enumeration. */
export enum FolderDocumentSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FolderSortRankAsc = 'FOLDER_SORT_RANK_ASC',
  FolderSortRankDesc = 'FOLDER_SORT_RANK_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SortingDateAsc = 'SORTING_DATE_ASC',
  SortingDateDesc = 'SORTING_DATE_DESC'
}

/** Pseudo state for document model. Coincides with FolderDocumentState. */
export enum FolderDocumentState {
  Created = 'CREATED',
  Deleted = 'DELETED'
}

/** An enumeration. */
export enum Frequency {
  Never = 'never',
  Weekly = 'weekly'
}

/** An enumeration. */
export enum FundAdminServiceDocumentType {
  Additional = 'additional',
  CapitalCallDetail = 'capital_call_detail',
  DistributionDetail = 'distribution_detail',
  FundraiseSubscription = 'fundraise_subscription',
  InvestorCommunication = 'investor_communication',
  PositionTransfer = 'position_transfer',
  Tax = 'tax',
  VendorPaymentInvoice = 'vendor_payment_invoice'
}

/** An enumeration. */
export enum FundAdminServiceObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  ExternalTicketIdentifierAsc = 'EXTERNAL_TICKET_IDENTIFIER_ASC',
  ExternalTicketIdentifierDesc = 'EXTERNAL_TICKET_IDENTIFIER_DESC',
  FundAdminServiceTypeIdAsc = 'FUND_ADMIN_SERVICE_TYPE_ID_ASC',
  FundAdminServiceTypeIdDesc = 'FUND_ADMIN_SERVICE_TYPE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPublishedAsc = 'IS_PUBLISHED_ASC',
  IsPublishedDesc = 'IS_PUBLISHED_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** An enumeration. */
export enum FundAdminServiceType {
  CapitalCall = 'capital_call',
  DeleteVendorInvoice = 'delete_vendor_invoice',
  Distribution = 'distribution',
  DocumentUploadInvestorCommunication = 'document_upload_investor_communication',
  EmailInvestorCommunication = 'email_investor_communication',
  FundClose = 'fund_close',
  InvoiceVendorPayment = 'invoice_vendor_payment',
  OtherPayment = 'other_payment',
  PositionTransfer = 'position_transfer',
  Redemption = 'redemption',
  StopVendorPayment = 'stop_vendor_payment',
  TaxDocuments = 'tax_documents'
}

/** An enumeration. */
export enum GlobalCapitalCallQuerySortEnum {
  BatchIdAsc = 'BATCH_ID_ASC',
  BatchIdDesc = 'BATCH_ID_DESC',
  DateDueAsc = 'DATE_DUE_ASC',
  DateDueDesc = 'DATE_DUE_DESC',
  HasDefaultedAsc = 'HAS_DEFAULTED_ASC',
  HasDefaultedDesc = 'HAS_DEFAULTED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalDistributionQuerySortEnum {
  DateDistributedAsc = 'DATE_DISTRIBUTED_ASC',
  DateDistributedDesc = 'DATE_DISTRIBUTED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalDocumentQuerySortEnum {
  ArenaNameAsc = 'ARENA_NAME_ASC',
  ArenaNameDesc = 'ARENA_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCollectionAsc = 'IS_COLLECTION_ASC',
  IsCollectionDesc = 'IS_COLLECTION_DESC',
  LastViewedAsc = 'LAST_VIEWED_ASC',
  LastViewedDesc = 'LAST_VIEWED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NdaIdAsc = 'NDA_ID_ASC',
  NdaIdDesc = 'NDA_ID_DESC',
  ReviewStatusAsc = 'REVIEW_STATUS_ASC',
  ReviewStatusDesc = 'REVIEW_STATUS_DESC',
  SortingDateAsc = 'SORTING_DATE_ASC',
  SortingDateDesc = 'SORTING_DATE_DESC'
}

/** An enumeration. */
export enum GlobalEmailQuerySortEnum {
  BodyHtmlAsc = 'BODY_HTML_ASC',
  BodyHtmlDesc = 'BODY_HTML_DESC',
  BodyTextAsc = 'BODY_TEXT_ASC',
  BodyTextDesc = 'BODY_TEXT_DESC',
  DateSentAsc = 'DATE_SENT_ASC',
  DateSentDesc = 'DATE_SENT_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC'
}

/** An enumeration. */
export enum GlobalManagementFeeQuerySortEnum {
  DateDueAsc = 'DATE_DUE_ASC',
  DateDueDesc = 'DATE_DUE_DESC',
  HasDefaultedAsc = 'HAS_DEFAULTED_ASC',
  HasDefaultedDesc = 'HAS_DEFAULTED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalNavQuerySortEnum {
  EffectiveDateAsc = 'EFFECTIVE_DATE_ASC',
  EffectiveDateDesc = 'EFFECTIVE_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalNetIncomeQuerySortEnum {
  DatePassedThroughAsc = 'DATE_PASSED_THROUGH_ASC',
  DatePassedThroughDesc = 'DATE_PASSED_THROUGH_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalTransactionQuerySortEnum {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EffectiveDateAsc = 'EFFECTIVE_DATE_ASC',
  EffectiveDateDesc = 'EFFECTIVE_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PaymentDateAsc = 'PAYMENT_DATE_ASC',
  PaymentDateDesc = 'PAYMENT_DATE_DESC'
}

/** An enumeration. */
export enum GpSignerNotificationPreference {
  Batched = 'batched',
  Individual = 'individual'
}

/** An enumeration. */
export enum GpxiLogObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DirectionAsc = 'DIRECTION_ASC',
  DirectionDesc = 'DIRECTION_DESC',
  EventTypeAsc = 'EVENT_TYPE_ASC',
  EventTypeDesc = 'EVENT_TYPE_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvalidRecordsAsc = 'INVALID_RECORDS_ASC',
  InvalidRecordsDesc = 'INVALID_RECORDS_DESC',
  IsNotDeletedAsc = 'IS_NOT_DELETED_ASC',
  IsNotDeletedDesc = 'IS_NOT_DELETED_DESC',
  LogAsc = 'LOG_ASC',
  LogDesc = 'LOG_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  RequestIdAsc = 'REQUEST_ID_ASC',
  RequestIdDesc = 'REQUEST_ID_DESC',
  SessionIdAsc = 'SESSION_ID_ASC',
  SessionIdDesc = 'SESSION_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  ValidRecordsAsc = 'VALID_RECORDS_ASC',
  ValidRecordsDesc = 'VALID_RECORDS_DESC'
}

/** An enumeration. */
export enum GroupObjectTypeSortEnum {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum InterestRateDescription {
  Fixed = 'fixed',
  Floating = 'floating'
}

/** An enumeration. */
export enum InternalJsqObjectType {
  Account = 'account',
  AccountContactMap = 'account_contact_map',
  AccountSettingsValues = 'account_settings_values',
  Acquisition = 'acquisition',
  Arena = 'arena',
  ArenaAccess = 'arena_access',
  ArenaDetail = 'arena_detail',
  Asset = 'asset',
  AssetDateSampledData = 'asset_date_sampled_data',
  BankAccount = 'bank_account',
  BulkArenaAccess = 'bulk_arena_access',
  BulkCountersign = 'bulk_countersign',
  CalendarEvent = 'calendar_event',
  CalendarEventParticipantMap = 'calendar_event_participant_map',
  CapitalCall = 'capital_call',
  CapitalCallBatch = 'capital_call_batch',
  CommPref = 'comm_pref',
  ComplianceProfile = 'compliance_profile',
  ConsolidatedPaymentBatch = 'consolidated_payment_batch',
  Contact = 'contact',
  CrmNotificationList = 'crm_notification_list',
  CumulativeMetrix = 'cumulative_metrix',
  DailyMetrix = 'daily_metrix',
  DataRoom = 'data_room',
  DdqStore = 'ddq_store',
  Disposition = 'disposition',
  Distribution = 'distribution',
  DistributionBatch = 'distribution_batch',
  Document = 'document',
  DocumentCategory = 'document_category',
  DocumentExportMetadata = 'document_export_metadata',
  DocumentFolder = 'document_folder',
  DocumentReviewerMember = 'document_reviewer_member',
  DocumentReviewerSettings = 'document_reviewer_settings',
  DocumentWatermark = 'document_watermark',
  DocumentWorkflowActions = 'document_workflow_actions',
  ESignatureDocument = 'e_signature_document',
  ESignatureGpSigner = 'e_signature_gp_signer',
  ESignatureLpConfigurator = 'e_signature_lp_configurator',
  ESignatureLpSigner = 'e_signature_lp_signer',
  ESignatureRequest = 'e_signature_request',
  ESignatureRequestBatch = 'e_signature_request_batch',
  ESignatureRequestRecipient = 'e_signature_request_recipient',
  ESignatureRequestTemplate = 'e_signature_request_template',
  Email = 'email',
  EmailBatch = 'email_batch',
  EmailDistributionList = 'email_distribution_list',
  EntityCollection = 'entity_collection',
  EventLog = 'event_log',
  ExtensionField = 'extension_field',
  ExtensionFieldEnum = 'extension_field_enum',
  ExtensionFieldValue = 'extension_field_value',
  FeatureFlag = 'feature_flag',
  FieldAccessRole = 'field_access_role',
  FieldAccessRoleObjectMap = 'field_access_role_object_map',
  FundAdminService = 'fund_admin_service',
  GlAccount = 'gl_account',
  GlTransaction = 'gl_transaction',
  GlTransactionType = 'gl_transaction_type',
  Group = 'group',
  ImportJob = 'import_job',
  ImportTemplate = 'import_template',
  InvestorDiligence = 'investor_diligence',
  InvestorGroup = 'investor_group',
  KycDetail = 'kyc_detail',
  KycDocument = 'kyc_document',
  KycDocumentVersion = 'kyc_document_version',
  KycDocumentVersionActivity = 'kyc_document_version_activity',
  LabelDisplaySettings = 'label_display_settings',
  Lead = 'lead',
  Loan = 'loan',
  Location = 'location',
  LpAccessRole = 'lp_access_role',
  LpAccessRoleGrant = 'lp_access_role_grant',
  LpAccessRoleScope = 'lp_access_role_scope',
  LpConsolidationRequest = 'lp_consolidation_request',
  LpProspectInvite = 'lp_prospect_invite',
  ManagementFeeBatch = 'management_fee_batch',
  Nav = 'nav',
  NavBatch = 'nav_batch',
  Nda = 'nda',
  NetIncome = 'net_income',
  NetIncomeBatch = 'net_income_batch',
  Note = 'note',
  NoteParticipantMap = 'note_participant_map',
  ObjectGroup = 'object_group',
  Offering = 'offering',
  OfferingEntityMap = 'offering_entity_map',
  Payable = 'payable',
  Payee = 'payee',
  Payment = 'payment',
  PaymentBatch = 'payment_batch',
  PaymentPref = 'payment_pref',
  PerformanceMetrics = 'performance_metrics',
  PortalLayoutConfig = 'portal_layout_config',
  Position = 'position',
  PositionAcmMap = 'position_acm_map',
  PositionIncrease = 'position_increase',
  PositionIncreaseInviteForm = 'position_increase_invite_form',
  PositionOpCoMap = 'position_op_co_map',
  Post = 'post',
  ProductType = 'product_type',
  Property = 'property',
  Prospect = 'prospect',
  ProspectContactMap = 'prospect_contact_map',
  Publication = 'publication',
  SettingsDetails = 'settings_details',
  SettingsValues = 'settings_values',
  SftpConnection = 'sftp_connection',
  SftpUser = 'sftp_user',
  StoredEmail = 'stored_email',
  StoredEmailParticipant = 'stored_email_participant',
  Subscription = 'subscription',
  SubscriptionBatch = 'subscription_batch',
  Task = 'task',
  Ticket = 'ticket',
  Transaction = 'transaction',
  TransactionBatch = 'transaction_batch',
  TwrPeriodMetric = 'twr_period_metric',
  UnitValue = 'unit_value',
  UnitValueBatch = 'unit_value_batch',
  User = 'user',
  WatchlistScreeningDetail = 'watchlist_screening_detail'
}

export enum InvestmentEntityStatus {
  Active = 'Active',
  Completed = 'Completed'
}

/** Investment filter options for portal hero metrics. */
export enum InvestmentFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Completed = 'COMPLETED'
}

/** An enumeration. */
export enum InvestmentOrder {
  CocYieldAsc = 'coc_yield_asc',
  CocYieldDesc = 'coc_yield_desc',
  CommitmentAsc = 'commitment_asc',
  CommitmentDesc = 'commitment_desc',
  ContributionsAsc = 'contributions_asc',
  ContributionsDesc = 'contributions_desc',
  DistributionsAsc = 'distributions_asc',
  DistributionsDesc = 'distributions_desc',
  DpiAsc = 'dpi_asc',
  DpiDesc = 'dpi_desc',
  DvpiAsc = 'dvpi_asc',
  DvpiDesc = 'dvpi_desc',
  EquityBalanceAsc = 'equity_balance_asc',
  EquityBalanceDesc = 'equity_balance_desc',
  Irr_1yrAsc = 'irr_1yr_asc',
  Irr_1yrDesc = 'irr_1yr_desc',
  Irr_3yrAsc = 'irr_3yr_asc',
  Irr_3yrDesc = 'irr_3yr_desc',
  Irr_5yrAsc = 'irr_5yr_asc',
  Irr_5yrDesc = 'irr_5yr_desc',
  Irr_10yrAsc = 'irr_10yr_asc',
  Irr_10yrDesc = 'irr_10yr_desc',
  IrrAsc = 'irr_asc',
  IrrDesc = 'irr_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  PercentOwnershipAsc = 'percent_ownership_asc',
  PercentOwnershipDesc = 'percent_ownership_desc',
  PositionOrAssetValueAsc = 'position_or_asset_value_asc',
  PositionOrAssetValueDesc = 'position_or_asset_value_desc',
  RedemptionsAsc = 'redemptions_asc',
  RedemptionsDesc = 'redemptions_desc',
  RvpiAsc = 'rvpi_asc',
  RvpiDesc = 'rvpi_desc',
  TotalExposureAsc = 'total_exposure_asc',
  TotalExposureDesc = 'total_exposure_desc',
  TvpiAsc = 'tvpi_asc',
  TvpiDesc = 'tvpi_desc',
  UnfundedCommitmentAsc = 'unfunded_commitment_asc',
  UnfundedCommitmentDesc = 'unfunded_commitment_desc',
  UnitValueAsc = 'unit_value_asc',
  UnitValueDesc = 'unit_value_desc',
  UnitsAsc = 'units_asc',
  UnitsDesc = 'units_desc'
}

/** An enumeration. */
export enum InvestorDiligenceCommentObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  CommentTypeAsc = 'COMMENT_TYPE_ASC',
  CommentTypeDesc = 'COMMENT_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvestorDiligenceIdAsc = 'INVESTOR_DILIGENCE_ID_ASC',
  InvestorDiligenceIdDesc = 'INVESTOR_DILIGENCE_ID_DESC',
  IsNotDeletedAsc = 'IS_NOT_DELETED_ASC',
  IsNotDeletedDesc = 'IS_NOT_DELETED_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC'
}

/** An enumeration. */
export enum InvestorDiligenceCommentType {
  Acknowledgment = 'ACKNOWLEDGMENT',
  Informational = 'INFORMATIONAL'
}

export enum InvestorDiligenceCommentTypesEnum {
  Acknowledgment = 'acknowledgment',
  Informational = 'informational'
}

/** An enumeration. */
export enum InvestorDiligenceEmailType {
  VerifyIdentityInvite = 'verify_identity_invite',
  VerifyIdentityInviteReminder = 'verify_identity_invite_reminder'
}

/** An enumeration. */
export enum InvestorDiligenceObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  ExternalObjectIdAsc = 'EXTERNAL_OBJECT_ID_ASC',
  ExternalObjectIdDesc = 'EXTERNAL_OBJECT_ID_DESC',
  ExternalObjectTypeAsc = 'EXTERNAL_OBJECT_TYPE_ASC',
  ExternalObjectTypeDesc = 'EXTERNAL_OBJECT_TYPE_DESC',
  InvestorDiligenceTypeAsc = 'INVESTOR_DILIGENCE_TYPE_ASC',
  InvestorDiligenceTypeDesc = 'INVESTOR_DILIGENCE_TYPE_DESC',
  PeerReviewerUserIdAsc = 'PEER_REVIEWER_USER_ID_ASC',
  PeerReviewerUserIdDesc = 'PEER_REVIEWER_USER_ID_DESC',
  PeerReviewEndDateAsc = 'PEER_REVIEW_END_DATE_ASC',
  PeerReviewEndDateDesc = 'PEER_REVIEW_END_DATE_DESC',
  PeerReviewStartDateAsc = 'PEER_REVIEW_START_DATE_ASC',
  PeerReviewStartDateDesc = 'PEER_REVIEW_START_DATE_DESC',
  ReviewerUserIdAsc = 'REVIEWER_USER_ID_ASC',
  ReviewerUserIdDesc = 'REVIEWER_USER_ID_DESC',
  ReviewEndDateAsc = 'REVIEW_END_DATE_ASC',
  ReviewEndDateDesc = 'REVIEW_END_DATE_DESC',
  ReviewStartDateAsc = 'REVIEW_START_DATE_ASC',
  ReviewStartDateDesc = 'REVIEW_START_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** An enumeration. */
export enum InvestorDiligenceStatus {
  Confirmed = 'confirmed',
  InPeerReview = 'in_peer_review',
  InReview = 'in_review',
  PendingPeerReview = 'pending_peer_review',
  PendingReview = 'pending_review',
  RequestedLpForInfo = 'requested_lp_for_info',
  Started = 'started'
}

/** An enumeration. */
export enum InvestorDiligenceType {
  Kyc = 'kyc',
  Manual = 'manual',
  WatchlistScreening = 'watchlist_screening'
}

/** An enumeration. */
export enum JsqObjectType {
  Account = 'account',
  AccountContactMap = 'account_contact_map',
  AccountSettingsValues = 'account_settings_values',
  Acquisition = 'acquisition',
  Arena = 'arena',
  ArenaAccess = 'arena_access',
  ArenaDetail = 'arena_detail',
  Asset = 'asset',
  AssetDateSampledData = 'asset_date_sampled_data',
  BankAccount = 'bank_account',
  BulkArenaAccess = 'bulk_arena_access',
  BulkCountersign = 'bulk_countersign',
  CalendarEvent = 'calendar_event',
  CalendarEventParticipantMap = 'calendar_event_participant_map',
  CapitalCall = 'capital_call',
  CapitalCallBatch = 'capital_call_batch',
  CommPref = 'comm_pref',
  ComplianceProfile = 'compliance_profile',
  ConsolidatedPaymentBatch = 'consolidated_payment_batch',
  Contact = 'contact',
  CrmNotificationList = 'crm_notification_list',
  CumulativeMetrix = 'cumulative_metrix',
  DailyMetrix = 'daily_metrix',
  DataRoom = 'data_room',
  DdqStore = 'ddq_store',
  Disposition = 'disposition',
  Distribution = 'distribution',
  DistributionBatch = 'distribution_batch',
  Document = 'document',
  DocumentCategory = 'document_category',
  DocumentExportMetadata = 'document_export_metadata',
  DocumentFolder = 'document_folder',
  DocumentReviewerMember = 'document_reviewer_member',
  DocumentReviewerSettings = 'document_reviewer_settings',
  DocumentWatermark = 'document_watermark',
  DocumentWorkflowActions = 'document_workflow_actions',
  ESignatureDocument = 'e_signature_document',
  ESignatureGpSigner = 'e_signature_gp_signer',
  ESignatureLpConfigurator = 'e_signature_lp_configurator',
  ESignatureLpSigner = 'e_signature_lp_signer',
  ESignatureRequest = 'e_signature_request',
  ESignatureRequestBatch = 'e_signature_request_batch',
  ESignatureRequestRecipient = 'e_signature_request_recipient',
  ESignatureRequestTemplate = 'e_signature_request_template',
  Email = 'email',
  EmailBatch = 'email_batch',
  EmailDistributionList = 'email_distribution_list',
  EntityCollection = 'entity_collection',
  EventLog = 'event_log',
  ExtensionField = 'extension_field',
  ExtensionFieldEnum = 'extension_field_enum',
  ExtensionFieldValue = 'extension_field_value',
  FeatureFlag = 'feature_flag',
  FieldAccessRole = 'field_access_role',
  FieldAccessRoleObjectMap = 'field_access_role_object_map',
  FundAdminService = 'fund_admin_service',
  GlAccount = 'gl_account',
  GlTransaction = 'gl_transaction',
  GlTransactionType = 'gl_transaction_type',
  Group = 'group',
  ImportJob = 'import_job',
  ImportTemplate = 'import_template',
  InvestorDiligence = 'investor_diligence',
  InvestorGroup = 'investor_group',
  KycDetail = 'kyc_detail',
  KycDocument = 'kyc_document',
  KycDocumentVersion = 'kyc_document_version',
  KycDocumentVersionActivity = 'kyc_document_version_activity',
  LabelDisplaySettings = 'label_display_settings',
  Lead = 'lead',
  Loan = 'loan',
  Location = 'location',
  LpAccessRole = 'lp_access_role',
  LpAccessRoleGrant = 'lp_access_role_grant',
  LpAccessRoleScope = 'lp_access_role_scope',
  LpConsolidationRequest = 'lp_consolidation_request',
  LpProspectInvite = 'lp_prospect_invite',
  ManagementFeeBatch = 'management_fee_batch',
  Nav = 'nav',
  NavBatch = 'nav_batch',
  Nda = 'nda',
  NetIncome = 'net_income',
  NetIncomeBatch = 'net_income_batch',
  Note = 'note',
  NoteParticipantMap = 'note_participant_map',
  ObjectGroup = 'object_group',
  Offering = 'offering',
  OfferingEntityMap = 'offering_entity_map',
  Payable = 'payable',
  Payee = 'payee',
  Payment = 'payment',
  PaymentBatch = 'payment_batch',
  PaymentPref = 'payment_pref',
  PerformanceMetrics = 'performance_metrics',
  PortalLayoutConfig = 'portal_layout_config',
  Position = 'position',
  PositionAcmMap = 'position_acm_map',
  PositionIncrease = 'position_increase',
  PositionIncreaseInviteForm = 'position_increase_invite_form',
  PositionOpCoMap = 'position_op_co_map',
  Post = 'post',
  ProductType = 'product_type',
  Property = 'property',
  Prospect = 'prospect',
  ProspectContactMap = 'prospect_contact_map',
  Publication = 'publication',
  SettingsDetails = 'settings_details',
  SettingsValues = 'settings_values',
  SftpConnection = 'sftp_connection',
  SftpUser = 'sftp_user',
  StoredEmail = 'stored_email',
  StoredEmailParticipant = 'stored_email_participant',
  Subscription = 'subscription',
  SubscriptionBatch = 'subscription_batch',
  Task = 'task',
  Ticket = 'ticket',
  Transaction = 'transaction',
  TransactionBatch = 'transaction_batch',
  TwrPeriodMetric = 'twr_period_metric',
  UnitValue = 'unit_value',
  UnitValueBatch = 'unit_value_batch',
  User = 'user',
  WatchlistScreeningDetail = 'watchlist_screening_detail'
}

/** An enumeration. */
export enum JobStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

/** An enumeration. */
export enum JobType {
  AccountDedup = 'AccountDedup',
  AccountExport = 'AccountExport',
  AccountPositionExport = 'AccountPositionExport',
  ActiveCaseLogExport = 'ActiveCaseLogExport',
  ActivityExport = 'ActivityExport',
  ActivityRegisterBackfill = 'ActivityRegisterBackfill',
  AnalystAuditLogExport = 'AnalystAuditLogExport',
  ApiCollectionDownload = 'ApiCollectionDownload',
  ArenaAccessExport = 'ArenaAccessExport',
  ArenaTransactionsExport = 'ArenaTransactionsExport',
  AssetExport = 'AssetExport',
  AsyncAuditLogDownload = 'AsyncAuditLogDownload',
  AutomatedPaymentsExport = 'AutomatedPaymentsExport',
  BulkDocumentPublish = 'BulkDocumentPublish',
  BulkPositionImportTask = 'BulkPositionImportTask',
  BulkUpdatePostSharing = 'BulkUpdatePostSharing',
  CapAcctBalExport = 'CapAcctBalExport',
  CapAcctBalStandardExport = 'CapAcctBalStandardExport',
  CapitalCallExport = 'CapitalCallExport',
  ColdStartMarketLens = 'ColdStartMarketLens',
  CollectionMatching = 'CollectionMatching',
  CommunicationSettingsExport = 'CommunicationSettingsExport',
  ComplianceDocumentUploadInviteEmail = 'ComplianceDocumentUploadInviteEmail',
  ConfigureDocumentReviewers = 'ConfigureDocumentReviewers',
  ConfigureIntegrationTask = 'ConfigureIntegrationTask',
  ContactCsvExport = 'ContactCSVExport',
  ContactDedup = 'ContactDedup',
  ContactImport = 'ContactImport',
  ContactInvestorReport = 'ContactInvestorReport',
  ContactPositionExport = 'ContactPositionExport',
  ContactReport = 'ContactReport',
  ContributionExport = 'ContributionExport',
  CreateEmailsForBatchSendTask = 'CreateEmailsForBatchSendTask',
  CreateLobChecks = 'CreateLobChecks',
  CrossEntityTransactionImport = 'CrossEntityTransactionImport',
  CurrencyRateBackfill = 'CurrencyRateBackfill',
  DataFabricBackfillAccounts = 'DataFabricBackfillAccounts',
  DataFabricBackfillArena = 'DataFabricBackfillArena',
  DataFabricBackfillCrm = 'DataFabricBackfillCrm',
  DataFabricBackfillEmail = 'DataFabricBackfillEmail',
  DataFabricBackfillEmailAttachment = 'DataFabricBackfillEmailAttachment',
  DataFabricBackfillFundraising = 'DataFabricBackfillFundraising',
  DataFabricBackfillPortalUser = 'DataFabricBackfillPortalUser',
  DataFabricNoteModelBackfillArena = 'DataFabricNoteModelBackfillArena',
  DataForgeBackfill = 'DataForgeBackfill',
  DataVaultBulkImport = 'DataVaultBulkImport',
  DelegatePerfMetrics = 'DelegatePerfMetrics',
  DeleteFilesFromS3 = 'DeleteFilesFromS3',
  DeleteUploadTransactionFiles = 'DeleteUploadTransactionFiles',
  DisableIntegrationTask = 'DisableIntegrationTask',
  DistributionExport = 'DistributionExport',
  DoWatchlistScreeningForDiligence = 'DoWatchlistScreeningForDiligence',
  DocumentReviewerSettingsExport = 'DocumentReviewerSettingsExport',
  DocumentsZip = 'DocumentsZip',
  DownloadArenasTouAndPp = 'DownloadArenasTouAndPP',
  DownloadAssetReport = 'DownloadAssetReport',
  DownloadAsyncJobErrorReport = 'DownloadAsyncJobErrorReport',
  DownloadCapitalAccountBalance = 'DownloadCapitalAccountBalance',
  DownloadPortalAccessData = 'DownloadPortalAccessData',
  ESignatureDownloadExecutedDocument = 'ESignatureDownloadExecutedDocument',
  ESignatureInitiateRequests = 'ESignatureInitiateRequests',
  ESignatureReInitiateRequest = 'ESignatureReInitiateRequest',
  EditContactsBulk = 'EditContactsBulk',
  EmailBatchSave = 'EmailBatchSave',
  EmailEncryptSmtpCredentials = 'EmailEncryptSmtpCredentials',
  EnableAuthorization = 'EnableAuthorization',
  EntityDocumentExport = 'EntityDocumentExport',
  ExportAllSubscriptions = 'ExportAllSubscriptions',
  ExtensionFieldExport = 'ExtensionFieldExport',
  ExtensionFieldImport = 'ExtensionFieldImport',
  FinalizeAssetsImport = 'FinalizeAssetsImport',
  FinalizeSubscriptionDocuments = 'FinalizeSubscriptionDocuments',
  GenerateImportAssetsPreview = 'GenerateImportAssetsPreview',
  GeneratePrivateEdgeTemplate = 'GeneratePrivateEdgeTemplate',
  GeneratePublication = 'GeneratePublication',
  IdentifySubscriptionReadyForBulkCountersign = 'IdentifySubscriptionReadyForBulkCountersign',
  InitiateBulkCountersign = 'InitiateBulkCountersign',
  InitiateGpCountersign = 'InitiateGPCountersign',
  InvestmentsExport = 'InvestmentsExport',
  KycWatchlistExport = 'KycWatchlistExport',
  ManagedEmailDnsInstructionEmail = 'ManagedEmailDnsInstructionEmail',
  ManuallyEditedEntityTransactionsExport = 'ManuallyEditedEntityTransactionsExport',
  MarketLensImport = 'MarketLensImport',
  MergeDocumentCategories = 'MergeDocumentCategories',
  MigrateOfferingToSubfolders = 'MigrateOfferingToSubfolders',
  NetIncomeExport = 'NetIncomeExport',
  OfferingProspectExport = 'OfferingProspectExport',
  OwnershipExport = 'OwnershipExport',
  PaymentExport = 'PaymentExport',
  PaymentInstructionChangeReadyForReviewEmail = 'PaymentInstructionChangeReadyForReviewEmail',
  PaymentPrefExport = 'PaymentPrefExport',
  PerfMetrics = 'PerfMetrics',
  PortalHeroMetricsExport = 'PortalHeroMetricsExport',
  PortalInvestmentsExport = 'PortalInvestmentsExport',
  PortalInvitationEmail = 'PortalInvitationEmail',
  PortalTransactionsExport = 'PortalTransactionsExport',
  PositionExport = 'PositionExport',
  PreviewAccountCleanup = 'PreviewAccountCleanup',
  PreviewAssetReport = 'PreviewAssetReport',
  PreviewCustomReport = 'PreviewCustomReport',
  PreviewCustomReportPublication = 'PreviewCustomReportPublication',
  PreviewPublication = 'PreviewPublication',
  PreviewPublicationAllRecipients = 'PreviewPublicationAllRecipients',
  ProcessCitNachaReturn = 'ProcessCitNachaReturn',
  ProspectBulkAction = 'ProspectBulkAction',
  ProspectCreation = 'ProspectCreation',
  PublicationMergeFieldsValidation = 'PublicationMergeFieldsValidation',
  PublishAssetReport = 'PublishAssetReport',
  PublishUploadTransactionFiles = 'PublishUploadTransactionFiles',
  RemoveTransferAccountingPositionAllocations = 'RemoveTransferAccountingPositionAllocations',
  ScheduleOfInvestmentExport = 'ScheduleOfInvestmentExport',
  SendDistributionDataToCrowdStreet = 'SendDistributionDataToCrowdStreet',
  StatsRecord = 'StatsRecord',
  SubscriptionSnapshot = 'SubscriptionSnapshot',
  TwrGlobalUserData = 'TWRGlobalUserData',
  TwrGlobalUserDataExport = 'TWRGlobalUserDataExport',
  TwrPeriodMetricsForEntity = 'TWRPeriodMetricsForEntity',
  TwrPeriodMetricsForPosition = 'TWRPeriodMetricsForPosition',
  TransactionDeletion = 'TransactionDeletion',
  TransactionExport = 'TransactionExport',
  TriggerBulkSyncTask = 'TriggerBulkSyncTask',
  /** @deprecated ENG-12545 */
  TurnOnWaterfallCalculationFix = 'TurnOnWaterfallCalculationFix',
  UpdateIntegrationPrivacyMaps = 'UpdateIntegrationPrivacyMaps',
  UpdateLobChecks = 'UpdateLobChecks',
  UpdatePositionAllocation = 'UpdatePositionAllocation',
  UpdatePositionAllocationPublication = 'UpdatePositionAllocationPublication',
  UpdatePositionAllocationWaterfall = 'UpdatePositionAllocationWaterfall',
  UpdateProspectContactMapAccessDate = 'UpdateProspectContactMapAccessDate',
  UserRolesExport = 'UserRolesExport',
  ValidateAmoebaState = 'ValidateAmoebaState',
  VerifyEmailBatchRecipientsTask = 'VerifyEmailBatchRecipientsTask',
  VerifySmtpCred = 'VerifySmtpCred',
  VerifySmtpHost = 'VerifySmtpHost',
  VoidBulkCountersignTask = 'VoidBulkCountersignTask',
  WaterfallCalculations = 'WaterfallCalculations',
  WaterfallError = 'WaterfallError',
  WaterfallPeriodRecords = 'WaterfallPeriodRecords',
  YardiImExport = 'YardiIMExport',
  YardiImImport = 'YardiIMImport',
  YardiImTransactionsImportUi = 'YardiIMTransactionsImportUI',
  YardiVoyagerPaymentsExport = 'YardiVoyagerPaymentsExport',
  ZendeskRequestTicketDetails = 'ZendeskRequestTicketDetails',
  ZendeskUserTag = 'ZendeskUserTag'
}

/** An enumeration. */
export enum KbaStatus {
  Attempted = 'attempted',
  DidNotAttempt = 'did_not_attempt',
  FailedThirdPartyCheck = 'failed_third_party_check',
  Ineligible = 'ineligible',
  PassedThirdPartyCheck = 'passed_third_party_check',
  ThirdPartyError = 'third_party_error'
}

/** An enumeration. */
export enum KycDocumentStatus {
  PassedPeerReview = 'passed_peer_review',
  PassedReview = 'passed_review',
  PendingReview = 'pending_review',
  RequestedLpForInfo = 'requested_lp_for_info',
  RequestedReviewerToRedo = 'requested_reviewer_to_redo'
}

/** An enumeration. */
export enum KycDocumentType {
  AuditedFinancial = 'audited_financial',
  CorporateResolution = 'corporate_resolution',
  File = 'file',
  FormationDocument = 'formation_document',
  IdentityDocument = 'identity_document',
  TaxDocument = 'tax_document'
}

/** An enumeration. */
export enum KycDocumentVersionActivityObjectTypeSortEnum {
  ActivityTypeAsc = 'ACTIVITY_TYPE_ASC',
  ActivityTypeDesc = 'ACTIVITY_TYPE_DESC',
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  KycDocumentVersionIdAsc = 'KYC_DOCUMENT_VERSION_ID_ASC',
  KycDocumentVersionIdDesc = 'KYC_DOCUMENT_VERSION_ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC'
}

/** An enumeration. */
export enum KycDocumentVersionActivityType {
  Comment = 'comment',
  PassPeerReview = 'pass_peer_review',
  PassReview = 'pass_review',
  RequestLpForInfo = 'request_lp_for_info',
  RequestReviewerToRedo = 'request_reviewer_to_redo'
}

/** GraphQL enum for label field names */
export enum LabelFieldNameEnum {
  AccountValue = 'ACCOUNT_VALUE',
  CapitalAccountBalance = 'CAPITAL_ACCOUNT_BALANCE',
  CapitalIn = 'CAPITAL_IN',
  CapitalOut = 'CAPITAL_OUT',
  Cashflow = 'CASHFLOW',
  CashOnCashReturn = 'CASH_ON_CASH_RETURN',
  ClosingDate = 'CLOSING_DATE',
  Commitment = 'COMMITMENT',
  Committed = 'COMMITTED',
  Contributions = 'CONTRIBUTIONS',
  Distributed = 'DISTRIBUTED',
  Distributions = 'DISTRIBUTIONS',
  Dpi = 'DPI',
  EquityBalance = 'EQUITY_BALANCE',
  EquityMultiple = 'EQUITY_MULTIPLE',
  ExpectedHoldTime = 'EXPECTED_HOLD_TIME',
  IndustrySector = 'INDUSTRY_SECTOR',
  Irr = 'IRR',
  Irr_1Yr = 'IRR_1YR',
  Irr_3Yr = 'IRR_3YR',
  Irr_5Yr = 'IRR_5YR',
  Irr_10Yr = 'IRR_10YR',
  MinimumInvestment = 'MINIMUM_INVESTMENT',
  NetIncome = 'NET_INCOME',
  OfferingSize = 'OFFERING_SIZE',
  OutstandingCapitalCalls = 'OUTSTANDING_CAPITAL_CALLS',
  Ownership = 'OWNERSHIP',
  ProductType = 'PRODUCT_TYPE',
  RecallableCapital = 'RECALLABLE_CAPITAL',
  Redemptions = 'REDEMPTIONS',
  RemainingRecallableCapital = 'REMAINING_RECALLABLE_CAPITAL',
  Rvpi = 'RVPI',
  Strategy = 'STRATEGY',
  TotalCapitalization = 'TOTAL_CAPITALIZATION',
  TotalEquity = 'TOTAL_EQUITY',
  TotalExposure = 'TOTAL_EXPOSURE',
  Tvpi = 'TVPI',
  Unfunded = 'UNFUNDED',
  Units = 'UNITS',
  UnitSize = 'UNIT_SIZE',
  UnitValue = 'UNIT_VALUE',
  Valuation = 'VALUATION',
  Value = 'VALUE',
  Yield = 'YIELD'
}

/** An enumeration. */
export enum LenderType {
  BalanceSheet = 'balance_sheet',
  Cmbs = 'cmbs',
  DebtFund = 'debt_fund',
  Gse = 'gse',
  InsuranceCompany = 'insurance_company'
}

/** An enumeration. */
export enum LienPosition {
  ANote = 'a_note',
  BNote = 'b_note',
  CNote = 'c_note',
  ConvertibleNote = 'convertible_note',
  Junior = 'junior',
  Mezzanine = 'mezzanine',
  Other = 'other',
  Senior = 'senior',
  Unsecured = 'unsecured'
}

/** An enumeration. */
export enum LoanIndex {
  Cmt = 'cmt',
  Libor = 'libor',
  Mta = 'mta',
  Prime = 'prime',
  Sofr = 'sofr'
}

/** An enumeration. */
export enum LoanMetricPeriodObjectTypeSortEnum {
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC'
}

/** An enumeration. */
export enum LoanType {
  Bridge = 'bridge',
  BuildToSuit = 'build_to_suit',
  Construction = 'construction',
  Land = 'land',
  LineOfCredit = 'line_of_credit',
  Permanent = 'permanent',
  Rehabilitation = 'rehabilitation'
}

/** An enumeration. */
export enum LpProfileQuestionBlockObjectTypeSortEnum {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  ModalContentAsc = 'MODAL_CONTENT_ASC',
  ModalContentDesc = 'MODAL_CONTENT_DESC',
  ModalTitleAsc = 'MODAL_TITLE_ASC',
  ModalTitleDesc = 'MODAL_TITLE_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SummaryAsc = 'SUMMARY_ASC',
  SummaryDesc = 'SUMMARY_DESC'
}

/** An enumeration. */
export enum LpProfileQuestionTypeEnum {
  MultiChoice = 'multi_choice',
  SingleChoice = 'single_choice'
}

/** An enumeration. */
export enum LpSubscriptionDocumentType {
  AuditedFinancial = 'audited_financial',
  CorporateResolution = 'corporate_resolution',
  File = 'file',
  FormationDocument = 'formation_document',
  IdentityDocument = 'identity_document',
  OfflineSubscriptionImport = 'offline_subscription_import',
  TaxDocument = 'tax_document'
}

/** An enumeration. */
export enum MarketTier {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary'
}

/** An enumeration. */
export enum MarketTierEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary'
}

/** An enumeration. */
export enum MatchingStrategy {
  DefaultSuggestions = 'DEFAULT_SUGGESTIONS',
  UniqueIdentifier = 'UNIQUE_IDENTIFIER'
}

/** An enumeration. */
export enum MetricsEstimateType {
  Open = 'open',
  Point = 'point',
  Range = 'range'
}

/** An enumeration. */
export enum MonthOrQuarter {
  April = 'april',
  August = 'august',
  December = 'december',
  February = 'february',
  FirstQuarter = 'first_quarter',
  FourthQuarter = 'fourth_quarter',
  January = 'january',
  July = 'july',
  June = 'june',
  March = 'march',
  May = 'may',
  November = 'november',
  October = 'october',
  SecondQuarter = 'second_quarter',
  September = 'september',
  ThirdQuarter = 'third_quarter'
}

/** An enumeration. */
export enum NaicsSector {
  Sector_11 = 'sector_11',
  Sector_21 = 'sector_21',
  Sector_22 = 'sector_22',
  Sector_23 = 'sector_23',
  Sector_31_33 = 'sector_31_33',
  Sector_42 = 'sector_42',
  Sector_44_45 = 'sector_44_45',
  Sector_48_49 = 'sector_48_49',
  Sector_51 = 'sector_51',
  Sector_52 = 'sector_52',
  Sector_53 = 'sector_53',
  Sector_54 = 'sector_54',
  Sector_55 = 'sector_55',
  Sector_56 = 'sector_56',
  Sector_61 = 'sector_61',
  Sector_62 = 'sector_62',
  Sector_71 = 'sector_71',
  Sector_72 = 'sector_72',
  Sector_81 = 'sector_81',
  Sector_92 = 'sector_92'
}

/** An enumeration. */
export enum NdaObjectTypeSortEnum {
  AgreementTextAsc = 'AGREEMENT_TEXT_ASC',
  AgreementTextDesc = 'AGREEMENT_TEXT_DESC',
  CustomerNameAsc = 'CUSTOMER_NAME_ASC',
  CustomerNameDesc = 'CUSTOMER_NAME_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RevisionAsc = 'REVISION_ASC',
  RevisionDesc = 'REVISION_DESC'
}

/** Enumeration for NDA requirement types at the prospect-contact level. */
export enum NdaRequirementType {
  Custom = 'CUSTOM',
  Executed = 'EXECUTED',
  Exempt = 'EXEMPT',
  UseDefault = 'USE_DEFAULT'
}

/** An enumeration. */
export enum NetIncomeDetailObjectTypeSortEnum {
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC'
}

/** An enumeration. */
export enum NetIncomeObjectTypeSortEnum {
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

export enum NewsletterSubscriptionTypes {
  Frequent = 'frequent',
  Infrequent = 'infrequent'
}

/** An enumeration. */
export enum NoteObjectTypeSortEnum {
  IsDraftAsc = 'IS_DRAFT_ASC',
  IsDraftDesc = 'IS_DRAFT_DESC',
  LocationAsc = 'LOCATION_ASC',
  LocationDesc = 'LOCATION_DESC',
  NoteTypeAsc = 'NOTE_TYPE_ASC',
  NoteTypeDesc = 'NOTE_TYPE_DESC',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC',
  ProvenanceAsc = 'PROVENANCE_ASC',
  ProvenanceDesc = 'PROVENANCE_DESC',
  SubProvenanceAsc = 'SUB_PROVENANCE_ASC',
  SubProvenanceDesc = 'SUB_PROVENANCE_DESC',
  SummaryAsc = 'SUMMARY_ASC',
  SummaryDesc = 'SUMMARY_DESC',
  TextAsc = 'TEXT_ASC',
  TextDesc = 'TEXT_DESC'
}

/**
 * Enumeration that defines the types of a note.
 *     Please update JsqNoteType in ActivityFeedCard/index.tsx when modifying this
 */
export enum NoteType {
  Custom = 'custom',
  Meeting = 'meeting',
  Note = 'note',
  PhoneCall = 'phone_call'
}

export enum NumberFilterExtendedType {
  Blank = 'blank',
  Equals = 'equals',
  GreaterThan = 'greater_than',
  GreaterThanOrEqual = 'greater_than_or_equal',
  InRange = 'in_range',
  LessThan = 'less_than',
  LessThanOrEqual = 'less_than_or_equal',
  NotBlank = 'not_blank',
  NotEquals = 'not_equals'
}

export enum NumberFilterType {
  Equals = 'equals',
  GreaterThanOrEqual = 'greater_than_or_equal',
  InRange = 'in_range',
  LessThanOrEqual = 'less_than_or_equal'
}

/** An enumeration. */
export enum ObjectFilter {
  IsAccountForOwningPositions = 'is_account_for_owning_positions',
  IsAnyStaff = 'is_any_staff',
  IsEntity = 'is_entity',
  IsEntityForUpdate = 'is_entity_for_update',
  IsNotEntity = 'is_not_entity',
  IsNotEntityForUpdate = 'is_not_entity_for_update',
  IsNotFundAdminStaff = 'is_not_fund_admin_staff',
  IsOrg = 'is_org',
  IsOrgExactNameMatch = 'is_org_exact_name_match',
  IsOrgForUpdate = 'is_org_for_update',
  IsPerson = 'is_person',
  IsPersonExactEmailMatch = 'is_person_exact_email_match',
  IsPersonForUpdate = 'is_person_for_update',
  IsStaff = 'is_staff',
  IsStaffCrmCrmr = 'is_staff_crm_crmr',
  IsStaffFm = 'is_staff_fm',
  IsStaffIm = 'is_staff_im',
  IsStaffOrPerson = 'is_staff_or_person'
}

/** An enumeration. */
export enum ObjectGroupObjectTypeSortEnum {
  IsFundAdminAsc = 'IS_FUND_ADMIN_ASC',
  IsFundAdminDesc = 'IS_FUND_ADMIN_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export enum ObjectType {
  Account = 'ACCOUNT',
  Arena = 'ARENA',
  BankAccount = 'BANK_ACCOUNT',
  CapitalCall = 'CAPITAL_CALL',
  CapitalCallBatch = 'CAPITAL_CALL_BATCH',
  ComplianceProfile = 'COMPLIANCE_PROFILE',
  Distribution = 'DISTRIBUTION',
  DistributionBatch = 'DISTRIBUTION_BATCH',
  OnboardingPayment = 'ONBOARDING_PAYMENT',
  OnboardingPaymentBatch = 'ONBOARDING_PAYMENT_BATCH',
  Payable = 'PAYABLE',
  Payee = 'PAYEE',
  Position = 'POSITION',
  Transaction = 'TRANSACTION',
  TransactionBatch = 'TRANSACTION_BATCH',
  User = 'USER'
}

/** An enumeration. */
export enum OfferingObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EquityGoalAsc = 'EQUITY_GOAL_ASC',
  EquityGoalDesc = 'EQUITY_GOAL_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC'
}

/** An enumeration. */
export enum OpcoIndustryType {
  AbsoluteReturn = 'absolute_return',
  AdministrativeAndSupportServices = 'administrative_and_support_services',
  AdvertisingTechnology = 'advertising_technology',
  Aerospace = 'aerospace',
  Automotive = 'automotive',
  Biotechnology = 'biotechnology',
  BusinessIntelligenceAndAnalytics = 'business_intelligence_and_analytics',
  BusinessProductivitySoftware = 'business_productivity_software',
  Cash = 'cash',
  CommunicationSoftware = 'communication_software',
  CommunicationsAndEnablingTechnologies = 'communications_and_enabling_technologies',
  ConsumerFinance = 'consumer_finance',
  ConsumerMediaAndAdvertising = 'consumer_media_and_advertising',
  ConsumerServicesAndTransactions = 'consumer_services_and_transactions',
  Credit = 'credit',
  CryptoCurrency = 'crypto_currency',
  CryptoFund = 'crypto_fund',
  DeveloperTools = 'developer_tools',
  Development = 'development',
  EducationTechnology = 'education_technology',
  Energy = 'energy',
  EnterpriseApplicationsAndServices = 'enterprise_applications_and_services',
  EnterpriseSoftware = 'enterprise_software',
  Entertainment = 'entertainment',
  EnvironmentalServices = 'environmental_services',
  Equity = 'equity',
  FinancialServices = 'financial_services',
  FoodAndBeverageStores = 'food_and_beverage_stores',
  FoodServicesAndDrinkingPlaces = 'food_services_and_drinking_places',
  FundInterest = 'fund_interest',
  FundsTrustsAndOtherFinancialVehicles = 'funds_trusts_and_other_financial_vehicles',
  GlobalEquity = 'global_equity',
  GlobalMacro = 'global_macro',
  Healthcare = 'healthcare',
  HealthcareLifeSciences = 'healthcare_life_sciences',
  HealthcareSoftware = 'healthcare_software',
  HedgedEquity = 'hedged_equity',
  Hospitality = 'hospitality',
  Industrial = 'industrial',
  Insurance = 'insurance',
  LifeLabScience = 'life_lab_science',
  Media = 'media',
  MediaAndInformationServices = 'media_and_information_services',
  MixedUse = 'mixed_use',
  Multifamily = 'multifamily',
  MultimediaAndDesignSoftware = 'multimedia_and_design_software',
  NetworkManagementSoftware = 'network_management_software',
  NonperformingLoan = 'nonperforming_loan',
  PerformingLoan = 'performing_loan',
  PrivateCredit = 'private_credit',
  PrivateEquity = 'private_equity',
  PublicEquity = 'public_equity',
  RealAssets = 'real_assets',
  RealEstate = 'real_estate',
  RealEstateHotel = 'real_estate_hotel',
  RealEstateMedicalOffices = 'real_estate_medical_offices',
  RealEstateMixedUse = 'real_estate_mixed_use',
  RealEstateMixedUseCommercial = 'real_estate_mixed_use_commercial',
  RealEstateMultifamily = 'real_estate_multifamily',
  RealEstateOffice = 'real_estate_office',
  RealEstateOwned = 'real_estate_owned',
  RealEstateRetail = 'real_estate_retail',
  RealEstateSeniorLiving = 'real_estate_senior_living',
  RentalAndLeasingServices = 'rental_and_leasing_services',
  Retail = 'retail',
  Software = 'software',
  SoftwareDevelopmentApplications = 'software_development_applications',
  SoftwareServices = 'software_services',
  SpecialSituation = 'special_situation',
  TradingAccount = 'trading_account',
  Venture = 'venture'
}

/** An enumeration. */
export enum OpcoSectorType {
  AccommodationAndFoodServices = 'accommodation_and_food_services',
  AdminSupportWasteManagementAndRemediationServices = 'admin_support_waste_management_and_remediation_services',
  AgricultureForestryFishingAndHunting = 'agriculture_forestry_fishing_and_hunting',
  ArtsEntertainmentAndRecreation = 'arts_entertainment_and_recreation',
  Construction = 'construction',
  ConsumerFinancialServices = 'consumer_financial_services',
  Credit = 'credit',
  EducationalServices = 'educational_services',
  FinanceAndInsurance = 'finance_and_insurance',
  HealthCareAndSocialAssistance = 'health_care_and_social_assistance',
  Industrial = 'industrial',
  Information = 'information',
  LongShortEquity = 'long_short_equity',
  ManagementOfCompaniesAndEnterprises = 'management_of_companies_and_enterprises',
  Manufacturing = 'manufacturing',
  Mining = 'mining',
  OilAndGas = 'oil_and_gas',
  Other = 'other',
  OtherServicesExceptPublicAdministration = 'other_services_except_public_administration',
  PrivateDebt = 'private_debt',
  ProfessionalScientificAndTechnicalServices = 'professional_scientific_and_technical_services',
  PublicAdministration = 'public_administration',
  RealEstate = 'real_estate',
  RealEstateAndRentalAndLeasing = 'real_estate_and_rental_and_leasing',
  RetailTrade = 'retail_trade',
  Software = 'software',
  TransportationAndWarehousing = 'transportation_and_warehousing',
  Utilities = 'utilities',
  WholesaleTrade = 'wholesale_trade'
}

export enum OrgSmtpAuthMethods {
  IpAllowList = 'IpAllowList',
  MicrosoftOAuth = 'MicrosoftOAuth',
  MultiAuth = 'MultiAuth',
  SingleAuth = 'SingleAuth'
}

/** An enumeration. */
export enum OwnershipCalculationMethod {
  CapitalAccountBalance = 'capital_account_balance',
  Commitment = 'commitment',
  Contribution = 'contribution',
  EquityBalance = 'equity_balance',
  Percentage = 'percentage',
  Unit = 'unit'
}

/** Payment methods */
export enum PaymentMethodEnum {
  Ach = 'ach',
  Bacs = 'bacs',
  Becs = 'becs',
  Check = 'check',
  Eft = 'eft',
  Other = 'other',
  Sepa = 'sepa',
  Wire = 'wire'
}

/** Used exclusively for inputs. This is due to federation requiring input enums to be updated across all subgraphs if changes are needed. */
export enum PaymentMethodInputEnum {
  Ach = 'ACH',
  Bacs = 'BACS',
  Becs = 'BECS',
  Check = 'Check',
  Eft = 'EFT',
  Other = 'Other',
  Sepa = 'SEPA',
  Wire = 'Wire'
}

/** An enumeration. */
export enum PaymentPersonType {
  LegalEntity = 'legal_entity',
  NaturalPerson = 'natural_person',
  Unknown = 'unknown'
}

/** An enumeration. */
export enum PaymentType {
  Amortizing = 'amortizing',
  InterestOnly = 'interest_only'
}

/** Enumeration that defines the types of phone numbers. */
export enum PhoneType {
  Home = 'home',
  HomeFax = 'home_fax',
  Mobile = 'mobile',
  Primary = 'primary',
  Unknown = 'unknown',
  UnknownFax = 'unknown_fax',
  Work = 'work',
  WorkFax = 'work_fax'
}

/** GraphQL enum for portal hero metrics field types. */
export enum PortalHeroMetricsFieldTypeEnum {
  ContactInvestmentsField = 'contact_investments_field',
  CountHoldings = 'count_holdings',
  CountInvestments = 'count_investments',
  ExtensionField = 'extension_field',
  PositionExtensionField = 'position_extension_field',
  TotalCommitment = 'total_commitment',
  TotalContributions = 'total_contributions',
  TotalDistributions = 'total_distributions',
  TotalValue = 'total_value'
}

/** An enumeration. */
export enum PortalInvitationJobObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  JobTypeAsc = 'JOB_TYPE_ASC',
  JobTypeDesc = 'JOB_TYPE_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** GraphQL enum for filtering a pie chart's positions by investment entity status. */
export enum PortalPieChartEntityStatusEnum {
  Active = 'active',
  All = 'all',
  Completed = 'completed'
}

export enum PortalStatus {
  /** Portal status is "Metrics not visible" */
  MetricsNotVisible = 'METRICS_NOT_VISIBLE',
  /** Portal status is "Metrics out-of-date" */
  MetricsOutOfDate = 'METRICS_OUT_OF_DATE',
  /** Portal status is "Not Visible" */
  NotVisible = 'NOT_VISIBLE',
  /** Portal status is "Visible", highlighted with the red color */
  NotVisibleDanger = 'NOT_VISIBLE_DANGER',
  /** Portal status is "Visible" */
  Visible = 'VISIBLE',
  /** Portal status is "Visible", highlighted with the green color */
  VisibleSuccess = 'VISIBLE_SUCCESS'
}

/**
 *
 *     This represents the statuses that we'll accept for requests for a particular position status. Positions will always
 *     be one of two statuses, either Active or Complete (deleted statuses are not considered). A status is made up of the
 *     position's status and the related entity's status. It follows this matrix:
 *     Active: position is active and entity is active.
 *     Completed: Any other case (position is inactive or entity is completed or has no status).
 *
 *     When requesting all position regardless of status, use "All". This is not a valid status for a position to have but
 *     is designed to return both active and completed positions.
 *
 *     If combining statuses from multiple positions, it's possible not all positions will be the same status so use None
 *     to represent that case.
 *
 */
export enum PositionEntityStatus {
  Active = 'active',
  All = 'all',
  Completed = 'completed'
}

/** An enumeration. */
export enum PositionObjectTypeSortEnum {
  DripPercentageAsc = 'DRIP_PERCENTAGE_ASC',
  DripPercentageDesc = 'DRIP_PERCENTAGE_DESC',
  IsIlpaGpReportingAsc = 'IS_ILPA_GP_REPORTING_ASC',
  IsIlpaGpReportingDesc = 'IS_ILPA_GP_REPORTING_DESC',
  PercentOwnershipManualAsc = 'PERCENT_OWNERSHIP_MANUAL_ASC',
  PercentOwnershipManualDesc = 'PERCENT_OWNERSHIP_MANUAL_DESC',
  ReceivesFeesAsc = 'RECEIVES_FEES_ASC',
  ReceivesFeesDesc = 'RECEIVES_FEES_DESC',
  ReceivesIlpaAccountStatementsAsc = 'RECEIVES_ILPA_ACCOUNT_STATEMENTS_ASC',
  ReceivesIlpaAccountStatementsDesc = 'RECEIVES_ILPA_ACCOUNT_STATEMENTS_DESC',
  ReceivesIlpaCapitalCallNoticesAsc = 'RECEIVES_ILPA_CAPITAL_CALL_NOTICES_ASC',
  ReceivesIlpaCapitalCallNoticesDesc = 'RECEIVES_ILPA_CAPITAL_CALL_NOTICES_DESC',
  ReceivesIlpaDistributionNoticesAsc = 'RECEIVES_ILPA_DISTRIBUTION_NOTICES_ASC',
  ReceivesIlpaDistributionNoticesDesc = 'RECEIVES_ILPA_DISTRIBUTION_NOTICES_DESC',
  RemittanceInstructionsAsc = 'REMITTANCE_INSTRUCTIONS_ASC',
  RemittanceInstructionsDesc = 'REMITTANCE_INSTRUCTIONS_DESC',
  ReportingCadenceAsc = 'REPORTING_CADENCE_ASC',
  ReportingCadenceDesc = 'REPORTING_CADENCE_DESC',
  UnitCountOwnershipAsc = 'UNIT_COUNT_OWNERSHIP_ASC',
  UnitCountOwnershipDesc = 'UNIT_COUNT_OWNERSHIP_DESC'
}

/** An enumeration. */
export enum PositionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** An enumeration. */
export enum PostStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

/** An enumeration. */
export enum PrimaryMarketType {
  EastAsia = 'east_asia',
  Europe = 'europe',
  LatinAmerica = 'latin_america',
  NorthAfrica = 'north_africa',
  NorthAmerica = 'north_america',
  SouthAsia = 'south_asia',
  SubSaharanAfrica = 'sub_saharan_africa'
}

export enum ProductSubtype {
  Agriculture = 'agriculture',
  AmusementPark = 'amusement_park',
  ApartmentMultifamilyTownhome = 'apartment_multifamily_townhome',
  AssistedLiving = 'assisted_living',
  Budget = 'budget',
  Casino = 'casino',
  CharterSchool = 'charter_school',
  ColdStorage = 'cold_storage',
  Commercial = 'commercial',
  CommunityCenter = 'community_center',
  Condominium = 'condominium',
  DataCenter = 'data_center',
  Duplex = 'duplex',
  FlexSpace = 'flex_space',
  Fourplex = 'fourplex',
  FullService = 'full_service',
  GardenStyle = 'garden_style',
  GolfCourse = 'golf_course',
  HighRise_10Plus = 'high_rise_10_plus',
  HighRise_25Plus = 'high_rise_25_plus',
  Hospice = 'hospice',
  Hospital = 'hospital',
  IndependentLiving = 'independent_living',
  LifestyleCenter = 'lifestyle_center',
  LimitedService = 'limited_service',
  LongTermAcuteCare = 'long_term_acute_care',
  LowRise = 'low_rise',
  LowRise_1_6 = 'low_rise_1_6',
  ManufacturedHousing = 'manufactured_housing',
  Manufacturing = 'manufacturing',
  Marina = 'marina',
  MedicalOffice = 'medical_office',
  MemoryCare = 'memory_care',
  MidRise_5_9 = 'mid_rise_5_9',
  MidRise_7_25 = 'mid_rise_7_25',
  MobileHomePark = 'mobile_home_park',
  MultiStory = 'multi_story',
  NeighborhoodCenter = 'neighborhood_center',
  NursingHomes = 'nursing_homes',
  OfficeShowroom = 'office_showroom',
  OtherEducationInfrastructure = 'other_education_infrastructure',
  OtherIndustrial = 'other_industrial',
  OtherRetail = 'other_retail',
  OutletCenter = 'outlet_center',
  ParkingStructure = 'parking_structure',
  PowerCenter = 'power_center',
  PrivateSchool = 'private_school',
  RaceTrack = 'race_track',
  RegionalMall = 'regional_mall',
  ResearchDevelopment = 'research_development',
  Residential = 'residential',
  Resort = 'resort',
  SingleFamilyDetached = 'single_family_detached',
  SingleStory = 'single_story',
  SingleTenant = 'single_tenant',
  Solar = 'solar',
  SportsRelated = 'sports_related',
  StripCenter = 'strip_center',
  SuperRegionalMall = 'super_regional_mall',
  SurfaceLot = 'surface_lot',
  TheaterConcertHall = 'theater_concert_hall',
  ThemeFestivalCenter = 'theme_festival_center',
  Timberland = 'timberland',
  Townhome = 'townhome',
  Townhouse = 'townhouse',
  Triplex = 'triplex',
  Warehouse = 'warehouse',
  Water = 'water',
  Wind = 'wind'
}

/** An enumeration. */
export enum ProductType {
  ApartmentMultifamily = 'apartment_multifamily',
  CondoDevelopment = 'condo_development',
  EducationInfrastructure = 'education_infrastructure',
  Entertainment = 'entertainment',
  HealthCare = 'health_care',
  Homebuilding = 'homebuilding',
  Hotel = 'hotel',
  Industrial = 'industrial',
  Infrastructure = 'infrastructure',
  Land = 'land',
  MixedUse = 'mixed_use',
  Office = 'office',
  Other = 'other',
  Parking = 'parking',
  Residential = 'residential',
  Retail = 'retail',
  SelfStorage = 'self_storage',
  SeniorLiving = 'senior_living',
  StudentHousing = 'student_housing',
  Unspecified = 'unspecified'
}

export enum PromptNameEnum {
  GpMakeoverPrompt = 'gp_makeover_prompt',
  MultiManagerWelcomePrompt = 'multi_manager_welcome_prompt',
  SingleManagerWelcomePrompt = 'single_manager_welcome_prompt'
}

/** An enumeration. */
export enum ProspectObjectTypeSortEnum {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  OfferingIdAsc = 'OFFERING_ID_ASC',
  OfferingIdDesc = 'OFFERING_ID_DESC',
  StatusIdAsc = 'STATUS_ID_ASC',
  StatusIdDesc = 'STATUS_ID_DESC'
}

/** An enumeration. */
export enum PublishStatus {
  Mixed = 'mixed',
  None = 'none',
  PublishedOnly = 'published_only',
  UnpublishedOnly = 'unpublished_only'
}

/** An enumeration. */
export enum QuestionTypeEnum {
  Choice = 'choice',
  Text = 'text'
}

/** An enumeration. */
export enum RelativePeriod {
  PresentOnly = 'present_only',
  Qoq = 'qoq',
  Yoy = 'yoy'
}

/** An enumeration. */
export enum ReportRequestType {
  ExcludeTransactions = 'exclude_transactions',
  Full = 'full',
  NotRequested = 'not_requested'
}

/** An enumeration. */
export enum ReportTransactionType {
  ContributionType = 'contribution_type',
  DistributionType = 'distribution_type',
  NavType = 'nav_type',
  NetIncomeType = 'net_income_type',
  RedemptionType = 'redemption_type'
}

/** An enumeration. */
export enum ReportingCadence {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

/** An enumeration. */
export enum ReportingValueBasisType {
  Fmv = 'fmv',
  TaxBasis = 'tax_basis'
}

/** An enumeration. */
export enum RiskScoreStatus {
  ChecksCompleted = 'ChecksCompleted',
  Error = 'Error',
  NotStarted = 'NotStarted',
  Pending = 'Pending'
}

/** An enumeration. */
export enum RoleObjectTypeSortEnum {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** An enumeration. */
export enum SsoProviderType {
  AzureAd = 'azure_ad',
  Custom = 'custom',
  Google = 'google',
  Okta = 'okta',
  Ping = 'ping'
}

/** An enumeration. */
export enum SecurityTriggerStatus {
  False = 'FALSE',
  True = 'TRUE',
  Unavailable = 'UNAVAILABLE'
}

/** An enumeration. */
export enum SessionLogObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IpAddressAsc = 'IP_ADDRESS_ASC',
  IpAddressDesc = 'IP_ADDRESS_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  UserAgentAsc = 'USER_AGENT_ASC',
  UserAgentDesc = 'USER_AGENT_DESC'
}

export enum SetFilterQuantifier {
  All = 'all',
  Any = 'any',
  None = 'none'
}

/** An enumeration. */
export enum SoboUserState {
  Active = 'active',
  Closed = 'closed',
  Error = 'error',
  Missing = 'missing',
  NotActivated = 'not_activated',
  PendingConsent = 'pending_consent'
}

/** An enumeration. */
export enum SsoStatus {
  Disabled = 'disabled',
  Optional = 'optional',
  Required = 'required'
}

/** An enumeration. */
export enum StateObjectTypeSortEnum {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NcreifDivisionAsc = 'NCREIF_DIVISION_ASC',
  NcreifDivisionDesc = 'NCREIF_DIVISION_DESC',
  NcreifRegionAsc = 'NCREIF_REGION_ASC',
  NcreifRegionDesc = 'NCREIF_REGION_DESC'
}

/** An enumeration. */
export enum StationeryObjectTypeSortEnum {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  IsDefaultAsc = 'IS_DEFAULT_ASC',
  IsDefaultDesc = 'IS_DEFAULT_DESC',
  MarginBottomAsc = 'MARGIN_BOTTOM_ASC',
  MarginBottomDesc = 'MARGIN_BOTTOM_DESC',
  MarginTopAsc = 'MARGIN_TOP_ASC',
  MarginTopDesc = 'MARGIN_TOP_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** An enumeration. */
export enum Strategy {
  Core = 'core',
  CorePlus = 'core_plus',
  Opportunistic = 'opportunistic',
  ValueAdd = 'value_add'
}

/** An enumeration. */
export enum SubscriptionBehavior {
  Commitment = 'commitment',
  InitialContribution = 'initial_contribution'
}

/**
 *
 *     Enumeration for how to filter the get_subscription_contacts function.
 *     IncludeAdditional means include everything (signers, non-signer natural persons and additional contacts)
 *     NoAdditional means everything except additional contacts (signers and non-signer natural persons)
 *     OnlySigners means only signatories that can sign (signers)
 *     ExcludeSigners means everything except signatories (non-signer natural persons and additional contacts)
 *
 */
export enum SubscriptionContactFilter {
  ExcludeSigners = 'ExcludeSigners',
  IncludeAdditional = 'IncludeAdditional',
  NoAdditional = 'NoAdditional',
  OnlySigners = 'OnlySigners'
}

/** An enumeration. */
export enum SubscriptionCounterpartyRole {
  BeneficialOwnerOnly = 'beneficial_owner_only',
  SignatoryAndBeneficialOwner = 'signatory_and_beneficial_owner',
  SignatoryOnly = 'signatory_only'
}

/** An enumeration. */
export enum SubscriptionCounterpartyType {
  LegalEntity = 'legal_entity',
  NaturalPerson = 'natural_person'
}

export enum SubscriptionMainLifecycleEnum {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Invited = 'INVITED',
  Started = 'STARTED'
}

export enum SubscriptionMainStageBlockedByEnum {
  Gp = 'GP',
  Lp = 'LP'
}

export enum SubscriptionMainStageNameEnum {
  ComplianceReview = 'COMPLIANCE_REVIEW',
  LpStepAdditionalInformation = 'LP_STEP_ADDITIONAL_INFORMATION',
  LpStepCommunicationPreferences = 'LP_STEP_COMMUNICATION_PREFERENCES',
  LpStepIdentityVerification = 'LP_STEP_IDENTITY_VERIFICATION',
  LpStepInvestmentAmount = 'LP_STEP_INVESTMENT_AMOUNT',
  LpStepKyc = 'LP_STEP_KYC',
  LpStepPaymentInstructions = 'LP_STEP_PAYMENT_INSTRUCTIONS',
  LpStepReview = 'LP_STEP_REVIEW',
  LpStepSign = 'LP_STEP_SIGN',
  LpStepSubscriberAccount = 'LP_STEP_SUBSCRIBER_ACCOUNT',
  LpStepSupportingDocuments = 'LP_STEP_SUPPORTING_DOCUMENTS',
  PositionCreationCollectAccount = 'POSITION_CREATION_COLLECT_ACCOUNT',
  PositionCreationCollectContacts = 'POSITION_CREATION_COLLECT_CONTACTS',
  PositionCreationCollectDocs = 'POSITION_CREATION_COLLECT_DOCS',
  PositionCreationSetPosition = 'POSITION_CREATION_SET_POSITION',
  StaffCounterSign = 'STAFF_COUNTER_SIGN',
  StaffReview = 'STAFF_REVIEW'
}

export enum SubscriptionMainStageStatusEnum {
  Blocked = 'BLOCKED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Started = 'STARTED',
  Unstarted = 'UNSTARTED'
}

/** An enumeration. */
export enum SubscriptionReviewerDecision {
  Approve = 'approve',
  InProgress = 'in_progress',
  Reject = 'reject'
}

/** An enumeration. */
export enum TableType {
  AccountContacts = 'AccountContacts',
  Accounts = 'Accounts',
  ActivityFeed = 'ActivityFeed',
  ApprovalRequests = 'ApprovalRequests',
  ContactPositions = 'ContactPositions',
  ContactProspects = 'ContactProspects',
  Contacts = 'Contacts',
  Entities = 'Entities',
  EntityPositions = 'EntityPositions',
  OfferingProspects = 'OfferingProspects',
  Offerings = 'Offerings'
}

/** An enumeration. */
export enum TagObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC',
  TagTextAsc = 'TAG_TEXT_ASC',
  TagTextDesc = 'TAG_TEXT_DESC'
}

/** An enumeration. */
export enum TaxDocumentDeliveryPref {
  Electronic = 'electronic',
  Paper = 'paper'
}

export enum TextFilterType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'ends_with',
  Equals = 'equals',
  NotBlank = 'not_blank',
  NotContains = 'not_contains',
  NotEqual = 'not_equal',
  StartsWith = 'starts_with'
}

/** An enumeration. */
export enum TimeSeriesDataType {
  Currency = 'currency',
  Date = 'date',
  Float = 'float',
  Int = 'int',
  NumericRange = 'numeric_range',
  Option = 'option',
  Percent = 'percent',
  String = 'string',
  Wallet = 'wallet'
}

/** An enumeration. */
export enum TransactionFrequency {
  Actual = 'actual',
  Annually = 'annually',
  Monthly = 'monthly',
  Quarterly = 'quarterly'
}

/** An enumeration. */
export enum TransactionObjectTypeSortEnum {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  PaymentDateAsc = 'PAYMENT_DATE_ASC',
  PaymentDateDesc = 'PAYMENT_DATE_DESC'
}

/** An enumeration. */
export enum TransactionTypeEffect {
  Negative = 'negative',
  Neutral = 'neutral',
  Positive = 'positive'
}

/** An enumeration. */
export enum TwoFaType {
  Email = 'email',
  Sms = 'sms',
  Totp = 'totp'
}

/** An enumeration. */
export enum UnifiedPortalAccountQuerySortEnum {
  AccountTypeAsc = 'ACCOUNT_TYPE_ASC',
  AccountTypeDesc = 'ACCOUNT_TYPE_DESC',
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  ArenaNameAsc = 'ARENA_NAME_ASC',
  ArenaNameDesc = 'ARENA_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisregardedEntityAsc = 'DISREGARDED_ENTITY_ASC',
  DisregardedEntityDesc = 'DISREGARDED_ENTITY_DESC',
  DisregardedEntityUltimateBeneficialOwnerAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_ASC',
  DisregardedEntityUltimateBeneficialOwnerDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_DESC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_ASC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_DESC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdTypeAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_TYPE_ASC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdTypeDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_TYPE_DESC',
  EndOfExtensionPeriodsAsc = 'END_OF_EXTENSION_PERIODS_ASC',
  EndOfExtensionPeriodsDesc = 'END_OF_EXTENSION_PERIODS_DESC',
  EndOfInvestingPeriodAsc = 'END_OF_INVESTING_PERIOD_ASC',
  EndOfInvestingPeriodDesc = 'END_OF_INVESTING_PERIOD_DESC',
  EndOfInvestmentLifeAsc = 'END_OF_INVESTMENT_LIFE_ASC',
  EndOfInvestmentLifeDesc = 'END_OF_INVESTMENT_LIFE_DESC',
  GpDisplayNameAsc = 'GP_DISPLAY_NAME_ASC',
  GpDisplayNameDesc = 'GP_DISPLAY_NAME_DESC',
  InceptionDateAsc = 'INCEPTION_DATE_ASC',
  InceptionDateDesc = 'INCEPTION_DATE_DESC',
  IsInvestmentEntityAsc = 'IS_INVESTMENT_ENTITY_ASC',
  IsInvestmentEntityDesc = 'IS_INVESTMENT_ENTITY_DESC',
  LpDisplayNameAsc = 'LP_DISPLAY_NAME_ASC',
  LpDisplayNameDesc = 'LP_DISPLAY_NAME_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  OverviewAndFinancialsPublishedAsc = 'OVERVIEW_AND_FINANCIALS_PUBLISHED_ASC',
  OverviewAndFinancialsPublishedDesc = 'OVERVIEW_AND_FINANCIALS_PUBLISHED_DESC',
  PrimaryPhotoIdAsc = 'PRIMARY_PHOTO_ID_ASC',
  PrimaryPhotoIdDesc = 'PRIMARY_PHOTO_ID_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TargetStrategyAsc = 'TARGET_STRATEGY_ASC',
  TargetStrategyDesc = 'TARGET_STRATEGY_DESC',
  TaxIdAsc = 'TAX_ID_ASC',
  TaxIdDesc = 'TAX_ID_DESC',
  TransferAccountingEnabledAsc = 'TRANSFER_ACCOUNTING_ENABLED_ASC',
  TransferAccountingEnabledDesc = 'TRANSFER_ACCOUNTING_ENABLED_DESC'
}

/** An enumeration. */
export enum UploadTransactionFileObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  BatchTypeAsc = 'BATCH_TYPE_ASC',
  BatchTypeDesc = 'BATCH_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  FileNameAsc = 'FILE_NAME_ASC',
  FileNameDesc = 'FILE_NAME_DESC',
  SheetNameAsc = 'SHEET_NAME_ASC',
  SheetNameDesc = 'SHEET_NAME_DESC'
}

/**
 *
 *     The intention of this enum is to provide a mechanism to be explicit about whether
 *     we are talking about a user record that is tied to a specific arena (ie. staff, single portal users)
 *     or global users, that are not tied to any arena.
 *     In the case that ARENA is specified as the user context, we should expect additional data
 *     specifying the arena in question to be present.
 *     On the other hand, if the context is GLOBAL, the arena_id of the user in question should be null.
 *
 */
export enum UserContext {
  Arena = 'arena',
  Global = 'global_'
}

/** An enumeration. */
export enum UserObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  DefaultCurrencyAsc = 'DEFAULT_CURRENCY_ASC',
  DefaultCurrencyDesc = 'DEFAULT_CURRENCY_DESC',
  EmailAddressAsc = 'EMAIL_ADDRESS_ASC',
  EmailAddressDesc = 'EMAIL_ADDRESS_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GlobalActivatedAsc = 'GLOBAL_ACTIVATED_ASC',
  GlobalActivatedDesc = 'GLOBAL_ACTIVATED_DESC',
  JobTitleAsc = 'JOB_TITLE_ASC',
  JobTitleDesc = 'JOB_TITLE_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LastViewedDashboardIdAsc = 'LAST_VIEWED_DASHBOARD_ID_ASC',
  LastViewedDashboardIdDesc = 'LAST_VIEWED_DASHBOARD_ID_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  NewsletterSubscribedAsc = 'NEWSLETTER_SUBSCRIBED_ASC',
  NewsletterSubscribedDesc = 'NEWSLETTER_SUBSCRIBED_DESC',
  NewsletterSubscriptionTypeAsc = 'NEWSLETTER_SUBSCRIPTION_TYPE_ASC',
  NewsletterSubscriptionTypeDesc = 'NEWSLETTER_SUBSCRIPTION_TYPE_DESC',
  SalutationNameAsc = 'SALUTATION_NAME_ASC',
  SalutationNameDesc = 'SALUTATION_NAME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum UserPrompts {
  GpMakeoverPrompt = 'gp_makeover_prompt',
  MultiManagerWelcomePrompt = 'multi_manager_welcome_prompt',
  SingleManagerWelcomePrompt = 'single_manager_welcome_prompt'
}

/** An enumeration. */
export enum VerificationStatus {
  Error = 'error',
  Unverified = 'unverified',
  Verified = 'verified'
}

/** An enumeration. */
export enum WatchlistScreeningStatus {
  FailedThirdPartyCheck = 'failed_third_party_check',
  PassedThirdPartyCheck = 'passed_third_party_check',
  PendingThirdPartyCheck = 'pending_third_party_check'
}

/** An enumeration. */
export enum WatermarkPlacement {
  BottomCenter = 'BottomCenter',
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
  DiagonalMiddleCenter = 'DiagonalMiddleCenter',
  TopCenter = 'TopCenter',
  TopLeft = 'TopLeft',
  TopRight = 'TopRight'
}
